(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"));
	else if(typeof define === 'function' && define.amd)
		define("react-icons", ["react"], factory);
	else if(typeof exports === 'object')
		exports["react-icons"] = factory(require("react"));
	else
		root["react-icons"] = factory(root["React"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_0__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 1);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_0__;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(2);


/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: external {"root":"React","commonjs2":"react","commonjs":"react","amd":"react","umd":"react"}
var external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react__ = __webpack_require__(0);
var external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default = /*#__PURE__*/__webpack_require__.n(external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react__);

// EXTERNAL MODULE: ../node_modules/prop-types/index.js
var prop_types = __webpack_require__(3);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);

// CONCATENATED MODULE: ./icons/images/indicators/Alert.svg
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}


/* harmony default export */ var Alert = (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === undefined ? {} : _ref$styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("svg", _extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 21 17" }, props), external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("path", { className: (styles["oc-icon-indicator"] || "oc-icon-indicator") + " " + (styles["oc-icon-status-attention"] || "oc-icon-status-attention"), d: "M16.3 12l-.1-2.1c0-2.5-1.6-4.7-4-5.5.2-1-.6-2-1.6-2.2s-2 .6-2.2 1.6v.6c-2.4.8-4 3-4 5.5V12c-.7 0-1.3.6-1.3 1.3 0 .7.6 1.3 1.3 1.3h4.4c-.2.8.2 1.7 1.1 1.9.8.2 1.7-.2 1.9-1.1.1-.3.1-.6 0-.9h4.4c.7 0 1.3-.5 1.3-1.2.1-.7-.5-1.3-1.2-1.3zM1.5 9c-.4 0-.8-.3-.8-.7-.9-3.5 1.2-7 4.7-7.9.5-.1.9.2 1.1.6.2.4-.2.9-.6 1.1-2.6.6-4.1 3.2-3.5 5.8 0 .5-.3.9-.7 1l-.2.1zM19.4 9c.4 0 .8-.3.9-.7.9-3.5-1.2-7-4.7-7.9-.5-.1-.9.2-1.1.6-.1.5.2.9.6 1.1 2.6.6 4.1 3.2 3.5 5.8-.1.5.2.9.6 1.1h.2z" }));
});
// CONCATENATED MODULE: ./icons/images/indicators/ArrowLeft.svg
var ArrowLeft__extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function ArrowLeft__objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}


/* harmony default export */ var ArrowLeft = (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === undefined ? {} : _ref$styles,
      props = ArrowLeft__objectWithoutProperties(_ref, ["styles"]);

  return external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("svg", ArrowLeft__extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 15 13" }, props), external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("path", { className: styles["oc-icon-indicator"] || "oc-icon-indicator", d: "M13.4 5H5l2.5-2.5c.6-.6.6-1.4 0-2s-1.4-.6-2 0l-5 5c-.6.5-.6 1.4 0 2l5 5c.6.6 1.4.6 2 0s.6-1.4 0-2L5 8h8.5c.8 0 1.5-.7 1.5-1.5S14.2 5 13.4 5z" }));
});
// CONCATENATED MODULE: ./icons/images/indicators/Attachment.svg
var Attachment__extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function Attachment__objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}


/* harmony default export */ var Attachment = (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === undefined ? {} : _ref$styles,
      props = Attachment__objectWithoutProperties(_ref, ["styles"]);

  return external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("svg", Attachment__extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 14 16" }, props), external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("path", { className: styles["oc-icon-indicator"] || "oc-icon-indicator", d: "M10 5.1l-1-1-5.1 5c-.7 1-.5 2.3.5 3 .7.5 1.8.5 2.5 0L13 6c1.3-1.5 1.2-3.7-.3-5.1a3.65 3.65 0 0 0-4.8 0L1.6 7.4c-2 2-2 5.1 0 7.1s5.1 2 7.1 0l4.4-4.4-1-1-4.4 4.4c-1.6 1.2-3.8.9-5-.7-1-1.3-1-3 0-4.3L9 2.1c1-.7 2.3-.5 3 .5.5.7.5 1.8 0 2.5l-6.1 6.1c-.3.2-.8.1-1-.2-.2-.2-.2-.6 0-.8L10 5.1z" }));
});
// CONCATENATED MODULE: ./icons/images/indicators/Burger.svg
var Burger__extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function Burger__objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}


/* harmony default export */ var Burger = (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === undefined ? {} : _ref$styles,
      props = Burger__objectWithoutProperties(_ref, ["styles"]);

  return external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("svg", Burger__extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 31 26" }, props), external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("path", { className: styles["oc-icon-burger"] || "oc-icon-burger", d: "M1.3.2h28.5c.5 0 1 .4 1 1v3.1c0 .5-.4 1-1 1H1.3c-.5 0-1-.4-1-1V1.1c0-.5.4-.9 1-.9zM1.3 10.5h28.5c.5 0 1 .4 1 1v3.1c0 .5-.4 1-1 1H1.3c-.5 0-1-.4-1-1v-3.1c0-.6.4-1 1-1zM1.3 20.8h28.5c.5 0 1 .4 1 1v3.1c0 .5-.4 1-1 1H1.3c-.5 0-1-.4-1-1v-3.1c0-.6.4-1 1-1z" }));
});
// CONCATENATED MODULE: ./icons/images/indicators/Burger-close.svg
var Burger_close__extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function Burger_close__objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}


/* harmony default export */ var Burger_close = (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === undefined ? {} : _ref$styles,
      props = Burger_close__objectWithoutProperties(_ref, ["styles"]);

  return external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("svg", Burger_close__extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 28 28" }, props), external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("path", { className: styles["oc-icon-burger-close"] || "oc-icon-burger-close", d: "M18 14l8.8-8.8c1.2-1 1.4-2.8.4-4.1-1-1.2-2.8-1.4-4.1-.4-.1.2-.2.3-.4.5L13.9 10 5.1 1.2C4 0 2.1 0 1 1.2S-.1 4.1 1 5.3L9.8 14 1 22.9C-.1 24-.1 25.9 1 27s3 1.1 4.1 0l8.8-8.8 8.8 8.8c1.2 1.1 3 1 4.1-.2 1-1.1 1-2.8 0-3.9L18 14z" }));
});
// CONCATENATED MODULE: ./icons/images/indicators/Calendar.svg
var Calendar__extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function Calendar__objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}


/* harmony default export */ var Calendar = (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === undefined ? {} : _ref$styles,
      props = Calendar__objectWithoutProperties(_ref, ["styles"]);

  return external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("svg", Calendar__extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 19 16" }, props), external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("path", { className: styles["oc-icon-indicator"] || "oc-icon-indicator", d: "M12.5 10h2v2h-2zM8.5 10h2v2h-2zM4.5 10h2v2h-2zM12.5 7h2v2h-2zM8.5 7h2v2h-2zM4.5 7h2v2h-2zM3.8.3h2.3v2.9H3.8zM12.9.3h2.3v2.9h-2.3z" }), external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("path", { className: styles["oc-icon-indicator"] || "oc-icon-indicator", d: "M16.1 3v1.1H12V3H7v1.1H2.9V3H0v12.8h19V3h-2.9zm.7 10.7H2.2V5.2h14.6v8.5z" }));
});
// CONCATENATED MODULE: ./icons/images/indicators/CaretLeft.svg
var CaretLeft__extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function CaretLeft__objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}


/* harmony default export */ var CaretLeft = (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === undefined ? {} : _ref$styles,
      props = CaretLeft__objectWithoutProperties(_ref, ["styles"]);

  return external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("svg", CaretLeft__extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 8 13" }, props), external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("path", { className: styles["oc-icon-indicator"] || "oc-icon-indicator", d: "M.1 6.5c0 .4.1.7.4 1l5 5c.6.6 1.4.6 2 0s.6-1.4 0-2l-4-4 4-4c.6-.6.6-1.4 0-2s-1.4-.6-2 0l-5 5c-.3.3-.4.6-.4 1z" }));
});
// CONCATENATED MODULE: ./icons/images/indicators/CaretRight.svg
var CaretRight__extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function CaretRight__objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}


/* harmony default export */ var CaretRight = (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === undefined ? {} : _ref$styles,
      props = CaretRight__objectWithoutProperties(_ref, ["styles"]);

  return external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("svg", CaretRight__extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 8 13" }, props), external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("path", { className: styles["oc-icon-indicator"] || "oc-icon-indicator", d: "M7.9 6.5c0-.4-.1-.7-.4-1l-5-5c-.6-.6-1.4-.6-2 0s-.6 1.4 0 2l4 4-4 4c-.6.6-.6 1.4 0 2s1.4.6 2 0l5-5c.3-.3.4-.6.4-1z" }));
});
// CONCATENATED MODULE: ./icons/images/indicators/CaretDoubleLeft.svg
var CaretDoubleLeft__extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function CaretDoubleLeft__objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}


/* harmony default export */ var CaretDoubleLeft = (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === undefined ? {} : _ref$styles,
      props = CaretDoubleLeft__objectWithoutProperties(_ref, ["styles"]);

  return external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("svg", CaretDoubleLeft__extends({ "data-name": "Layer 1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 15.8 13" }, props), external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("path", { className: styles["oc-icon-indicator"] || "oc-icon-indicator", d: "M7.5 10.5a1.34 1.34 0 0 1 0 2 1.34 1.34 0 0 1-2 0l-5-5a1.28 1.28 0 0 1-.4-1 1.28 1.28 0 0 1 .4-1l5-5a1.34 1.34 0 0 1 2 0 1.34 1.34 0 0 1 0 2l-4 4zm3.85-4l4-4a1.34 1.34 0 0 0 0-2 1.34 1.34 0 0 0-2 0l-5 5a1.28 1.28 0 0 0-.4 1 1.28 1.28 0 0 0 .4 1l5 5a1.41 1.41 0 0 0 2-2z" }));
});
// CONCATENATED MODULE: ./icons/images/indicators/CaretDoubleRight.svg
var CaretDoubleRight__extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function CaretDoubleRight__objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}


/* harmony default export */ var CaretDoubleRight = (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === undefined ? {} : _ref$styles,
      props = CaretDoubleRight__objectWithoutProperties(_ref, ["styles"]);

  return external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("svg", CaretDoubleRight__extends({ "data-name": "Layer 1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 15.75 13" }, props), external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("path", { className: styles["oc-icon-indicator"] || "oc-icon-indicator", d: "M7.9 6.5a1.28 1.28 0 0 1-.4 1l-5 5a1.34 1.34 0 0 1-2 0 1.34 1.34 0 0 1 0-2l4-4-4-4a1.34 1.34 0 0 1 0-2 1.34 1.34 0 0 1 2 0l5 5a1.28 1.28 0 0 1 .4 1zm7.45-1l-5-5a1.34 1.34 0 0 0-2 0 1.34 1.34 0 0 0 0 2l4 4-4 4a1.34 1.34 0 0 0 0 2 1.34 1.34 0 0 0 2 0l5-5a1.28 1.28 0 0 0 .4-1 1.28 1.28 0 0 0-.4-1z" }));
});
// CONCATENATED MODULE: ./icons/images/indicators/Clock.svg
var Clock__extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function Clock__objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}


/* harmony default export */ var Clock = (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === undefined ? {} : _ref$styles,
      props = Clock__objectWithoutProperties(_ref, ["styles"]);

  return external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("svg", Clock__extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 18 18" }, props), external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("path", { className: styles["oc-icon-indicator"] || "oc-icon-indicator", d: "M9 18c-5 0-9-4-9-9s4-9 9-9 9 4 9 9-4 9-9 9zM9 2C5.1 2 2 5.1 2 9s3.1 7 7 7 7-3.1 7-7-3.1-7-7-7z" }), external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("path", { className: styles["oc-icon-indicator"] || "oc-icon-indicator", d: "M11.8 11H8.1c-.6 0-1-.4-1-1s.4-1 1-1h3.8c.6 0 1 .4 1 1-.1.6-.5 1-1.1 1z" }), external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("path", { className: styles["oc-icon-indicator"] || "oc-icon-indicator", d: "M8 11c-.6 0-1-.4-1-1V5c0-.6.4-1 1-1s1 .4 1 1v5c0 .6-.4 1-1 1z" }));
});
// CONCATENATED MODULE: ./icons/images/indicators/Close.svg
var Close__extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function Close__objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}


/* harmony default export */ var Close = (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === undefined ? {} : _ref$styles,
      props = Close__objectWithoutProperties(_ref, ["styles"]);

  return external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("svg", Close__extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 9 9" }, props), external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("path", { className: styles["oc-icon-indicator"] || "oc-icon-indicator", d: "M5.8 4.5l2.9-2.9c.4-.4.4-1 0-1.3s-1-.4-1.3 0L4.5 3.2 1.6.3C1.2-.1.6-.1.3.3s-.4 1 0 1.3l2.9 2.9L.3 7.4c-.4.4-.4 1 0 1.3s1 .4 1.3 0l2.9-2.9 2.9 2.9c.4.4 1 .4 1.3 0s.4-1 0-1.3L5.8 4.5z" }));
});
// CONCATENATED MODULE: ./icons/images/indicators/Comment.svg
var Comment__extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function Comment__objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}


/* harmony default export */ var Comment = (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === undefined ? {} : _ref$styles,
      props = Comment__objectWithoutProperties(_ref, ["styles"]);

  return external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("svg", Comment__extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 15 15" }, props), external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("path", { className: styles["oc-icon-indicator"] || "oc-icon-indicator", d: "M14.8 1.5c0-.7-.6-1.3-1.3-1.3h-12C.8.2.2.8.2 1.5v13.4s1.9-4 2.7-4h10.7c.7 0 1.3-.6 1.3-1.3V1.5h-.1z" }));
});
// CONCATENATED MODULE: ./icons/images/indicators/Commented.svg
var Commented__extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function Commented__objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}


/* harmony default export */ var Commented = (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === undefined ? {} : _ref$styles,
      props = Commented__objectWithoutProperties(_ref, ["styles"]);

  return external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("svg", Commented__extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 15" }, props), external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("path", { className: styles["oc-icon-indicator"] || "oc-icon-indicator", d: "M14.4 0h-12C1.5.1.7.7.4 1.6V15c.1 0 2.6-4 3.4-4h10.7c.7-.1 1.1-.6 1.1-1.3V1.6C15.5.9 15.2 0 14.4 0zM8.5 7h-5V5h5v2zm4-3h-9V2h9v2z" }));
});
// CONCATENATED MODULE: ./icons/images/indicators/Critical.svg
var Critical__extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function Critical__objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}


/* harmony default export */ var Critical = (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === undefined ? {} : _ref$styles,
      props = Critical__objectWithoutProperties(_ref, ["styles"]);

  return external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("svg", Critical__extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20" }, props), external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("path", { className: (styles["oc-icon-indicator"] || "oc-icon-indicator") + " " + (styles["oc-icon-status-error"] || "oc-icon-status-error"), d: "M14.1 0H5.9L0 5.9v8.3L5.9 20h8.3l5.9-5.9V5.9l-6-5.9zm.6 13.2c.4.3.3 1 0 1.4-.3.4-1 .4-1.4 0L10 11.4l-3.2 3.2c-.3.4-1 .3-1.4 0-.4-.3-.4-1 0-1.4L8.6 10 5.3 6.8c-.4-.3-.3-1 0-1.4.3-.4 1-.4 1.4 0L10 8.6l3.2-3.2c.3-.4 1-.3 1.4 0 .4.3.4 1 0 1.4L11.4 10l3.3 3.2z" }));
});
// CONCATENATED MODULE: ./icons/images/indicators/Delete.svg
var Delete__extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function Delete__objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}


/* harmony default export */ var Delete = (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === undefined ? {} : _ref$styles,
      props = Delete__objectWithoutProperties(_ref, ["styles"]);

  return external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("svg", Delete__extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 12 17" }, props), external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("path", { className: styles["oc-icon-indicator"] || "oc-icon-indicator", d: "M9.5 2.2L8.4.4H3.6l-1 1.8H.1v2h11.8v-2H9.5zm-5.7-.1l.4-.7h3.6l.4.7H3.8zM.1 16.6h11.8v-11H.1v11zm9.4-8.4h1v6h-1v-6zm-2 0h1v6h-1v-6zm-2 0h1v6h-1v-6zm-2 0h1v6h-1v-6zm-2 0h1v6h-1v-6z" }));
});
// CONCATENATED MODULE: ./icons/images/indicators/Deleted.svg
var Deleted__extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function Deleted__objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}


/* harmony default export */ var Deleted = (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === undefined ? {} : _ref$styles,
      props = Deleted__objectWithoutProperties(_ref, ["styles"]);

  return external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("svg", Deleted__extends({ "data-name": "Layer 1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 9 9" }, props), external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("path", { className: styles["oc-icon-indicator"] || "oc-icon-indicator", d: "M7.68 7.68a.91.91 0 0 1-1.29 0L4.5 5.79 2.61 7.68a.91.91 0 1 1-1.29-1.29L3.21 4.5 1.32 2.61a.91.91 0 0 1 1.29-1.29L4.5 3.21l1.89-1.89a.91.91 0 1 1 1.29 1.29L5.79 4.5l1.89 1.89a.91.91 0 0 1 0 1.29z" }));
});
// CONCATENATED MODULE: ./icons/images/indicators/DraggingArrows.svg
var DraggingArrows__extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function DraggingArrows__objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}


/* harmony default export */ var DraggingArrows = (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === undefined ? {} : _ref$styles,
      props = DraggingArrows__objectWithoutProperties(_ref, ["styles"]);

  return external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("svg", DraggingArrows__extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 17 22" }, props), external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("path", { className: styles["oc-icon-indicator"] || "oc-icon-indicator", d: "M11 14.3h5.7l-8.2 7.6-8.2-7.6H6V7.7H.3L8.5.1l8.2 7.6H11z" }));
});
// CONCATENATED MODULE: ./icons/images/indicators/Edit.svg
var Edit__extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function Edit__objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}


/* harmony default export */ var Edit = (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === undefined ? {} : _ref$styles,
      props = Edit__objectWithoutProperties(_ref, ["styles"]);

  return external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("svg", Edit__extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 19 19" }, props), external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("path", { className: styles["oc-icon-indicator"] || "oc-icon-indicator", d: "M17.7 1.4c1.1.9 1.3 2.7.3 3.9l-.2.2-9.3 9.3-4.2-4.2 9.3-9.3c1.1-1.1 2.8-1.1 4-.1 0 .1.1.1.1.2zM.4 18.6l6.8-2.3-4.6-4.5z" }));
});
// CONCATENATED MODULE: ./icons/images/indicators/Email.svg
var Email__extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function Email__objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}


/* harmony default export */ var Email = (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === undefined ? {} : _ref$styles,
      props = Email__objectWithoutProperties(_ref, ["styles"]);

  return external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("svg", Email__extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 17 12" }, props), external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("path", { className: styles["oc-icon-indicator"] || "oc-icon-indicator", d: "M15.3.1H1.7l6.8 5.1z" }), external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("path", { className: styles["oc-icon-indicator"] || "oc-icon-indicator", d: "M9.1 7.3l-.1.1h-.1c-.1.1-.3.1-.4.1-.1 0-.3 0-.4-.1H8l-.1-.1L0 1.4v10.5h17V1.4L9.1 7.3z" }));
});
// CONCATENATED MODULE: ./icons/images/indicators/Error.svg
var Error__extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function Error__objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}


/* harmony default export */ var Error = (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === undefined ? {} : _ref$styles,
      props = Error__objectWithoutProperties(_ref, ["styles"]);

  return external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("svg", Error__extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20" }, props), external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("path", { className: (styles["oc-icon-indicator"] || "oc-icon-indicator") + " " + (styles["oc-icon-status-error"] || "oc-icon-status-error"), d: "M20 5.9v8.3L14.1 20H5.9L0 14.1V5.9L5.9 0h8.3L20 5.9zM8.5 10.1c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3v-4c0-.7-.6-1.3-1.3-1.3-.7 0-1.3.6-1.3 1.3v4zm2.9 4.4c-.1-.9-.9-1.6-1.7-1.5-.8.1-1.4.7-1.5 1.5-.1.9.6 1.7 1.5 1.7.9.1 1.7-.6 1.7-1.5.1-.1.1-.1 0-.2z" }));
});
// CONCATENATED MODULE: ./icons/images/indicators/Exclamation.svg
var Exclamation__extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function Exclamation__objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}


/* harmony default export */ var Exclamation = (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === undefined ? {} : _ref$styles,
      props = Exclamation__objectWithoutProperties(_ref, ["styles"]);

  return external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("svg", Exclamation__extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 5 18" }, props), external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("circle", { className: styles["oc-icon-indicator"] || "oc-icon-indicator", cx: "2.5", cy: "15.6", r: "2.4" }), external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("path", { className: styles["oc-icon-indicator"] || "oc-icon-indicator", d: "M2.5 11.2c-1.1 0-2-.9-2-2V2c0-1.1.9-2 2-2s2 .9 2 2v7.3c0 1-.9 1.9-2 1.9z" }));
});
// CONCATENATED MODULE: ./icons/images/indicators/Export.svg
var Export__extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function Export__objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}


/* harmony default export */ var Export = (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === undefined ? {} : _ref$styles,
      props = Export__objectWithoutProperties(_ref, ["styles"]);

  return external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("svg", Export__extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 22 15" }, props), external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("path", { className: styles["oc-icon-indicator"] || "oc-icon-indicator", d: "M14 10.2v2.4H2.1V2.4H14v1.8h2V.4H.1v14.2H16v-4.4z" }), external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("path", { className: styles["oc-icon-indicator"] || "oc-icon-indicator", d: "M18 4.3l3.9 2.9-3.9 3v-2H9.6c-.6 0-1-.4-1-1s.4-1 1-1H18V4.3" }));
});
// CONCATENATED MODULE: ./icons/images/indicators/Filtering.svg
var Filtering__extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function Filtering__objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}


/* harmony default export */ var Filtering = (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === undefined ? {} : _ref$styles,
      props = Filtering__objectWithoutProperties(_ref, ["styles"]);

  return external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("svg", Filtering__extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 9 8" }, props), external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("path", { className: styles["oc-icon-indicator"] || "oc-icon-indicator", d: "M8.8.2H.2l3.5 4.5v2.1l1.3 1 .1-3z" }));
});
// CONCATENATED MODULE: ./icons/images/indicators/Flagged.svg
var Flagged__extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function Flagged__objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}


/* harmony default export */ var Flagged = (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === undefined ? {} : _ref$styles,
      props = Flagged__objectWithoutProperties(_ref, ["styles"]);

  return external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("svg", Flagged__extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16" }, props), external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("path", { className: styles["oc-icon-indicator"] || "oc-icon-indicator", d: "M.1.9h2.4v14.9H.1zM4.4 9.6c1.2-.7 2.6-.9 4-.6 1.1.3 2.3 2.5 3.5 2.5 3.8 0 3.9-1 3.9-1V1.9s-.2 1-3.9 1C10.7 2.9 9.4.7 8.4.4 7 .1 5.6.2 4.4.9v8.7z" }));
});
// CONCATENATED MODULE: ./icons/images/indicators/Folder.svg
var Folder__extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function Folder__objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}


/* harmony default export */ var Folder = (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === undefined ? {} : _ref$styles,
      props = Folder__objectWithoutProperties(_ref, ["styles"]);

  return external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("svg", Folder__extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 17 15" }, props), external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("path", { className: styles["oc-icon-indicator"] || "oc-icon-indicator", d: "M16.8 14.7H.2V.3h6.4l2.2 2h8z" }));
});
// CONCATENATED MODULE: ./icons/images/indicators/Help.svg
var Help__extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function Help__objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}


/* harmony default export */ var Help = (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === undefined ? {} : _ref$styles,
      props = Help__objectWithoutProperties(_ref, ["styles"]);

  return external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("svg", Help__extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20" }, props), external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("path", { className: styles["oc-icon-indicator"] || "oc-icon-indicator", d: "M10 0C4.5 0 0 4.5 0 10s4.5 10 10 10 10-4.5 10-10S15.5 0 10 0zm.8 14.8H9.2v-1.5h1.6v1.5zm2.3-5.5c-.4.5-.9 1-1.4 1.4-.3.3-.5.6-.7.9-.1.4-.2.8-.1 1.2H9.2v-.6c0-.5.1-.9.3-1.4.3-.5.6-.9 1-1.2.3-.3.6-.5.9-.9.2-.2.2-.4.2-.7 0-.3-.2-.7-.4-.9-.3-.3-.7-.4-1.1-.4-.4.2-.8.3-1.2.6-.3.3-.5.7-.6 1.2l-1.6-.2c.1-.8.4-1.5 1-1.9.6-.6 1.5-.9 2.3-.9.9 0 1.8.2 2.5.8.6.5.9 1.1.9 1.9 0 .4-.1.8-.3 1.1z" }));
});
// CONCATENATED MODULE: ./icons/images/indicators/Info.svg
var Info__extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function Info__objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}


/* harmony default export */ var Info = (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === undefined ? {} : _ref$styles,
      props = Info__objectWithoutProperties(_ref, ["styles"]);

  return external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("svg", Info__extends({ "data-name": "Layer 1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 30 30" }, props), external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("path", { className: styles["oc-icon-light-gray"] || "oc-icon-light-gray", d: "M15 0a15 15 0 1 0 15 15A15 15 0 0 0 15 0zm1.8 23.7h-3.6V11.6h3.6zM15 10.5a2.1 2.1 0 1 1 2.1-2.1 2.1 2.1 0 0 1-2.1 2.1z" }));
});
// CONCATENATED MODULE: ./icons/images/indicators/Inspected.svg
var Inspected__extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function Inspected__objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}


/* harmony default export */ var Inspected = (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === undefined ? {} : _ref$styles,
      props = Inspected__objectWithoutProperties(_ref, ["styles"]);

  return external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("svg", Inspected__extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 17 12" }, props), external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("path", { className: styles["oc-icon-indicator"] || "oc-icon-indicator", d: "M8.5 12C4.1 12 .7 6.8.5 6.6c-.2-.3-.2-.8 0-1.1.2-.3 3.6-5.5 8-5.5s7.8 5.2 8 5.4c.2.3.2.8 0 1.1-.2.3-3.6 5.5-8 5.5zM2.6 6c.9 1.2 3.3 4 5.9 4 2.4 0 4.8-2.5 5.9-3.9-.9-1.2-3.3-4-5.9-4S3.5 4.8 2.6 6z" }), external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("circle", { className: styles["oc-icon-indicator"] || "oc-icon-indicator", cx: "8.4", cy: "5.8", r: "2.8" }));
});
// CONCATENATED MODULE: ./icons/images/indicators/InspectedAndApproved.svg
var InspectedAndApproved__extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function InspectedAndApproved__objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}


/* harmony default export */ var InspectedAndApproved = (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === undefined ? {} : _ref$styles,
      props = InspectedAndApproved__objectWithoutProperties(_ref, ["styles"]);

  return external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("svg", InspectedAndApproved__extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 15" }, props), external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("circle", { className: styles["oc-icon-indicator"] || "oc-icon-indicator", cx: "8.4", cy: "5.9", r: "2.8" }), external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("path", { className: styles["oc-icon-indicator"] || "oc-icon-indicator", d: "M10.5 11.2c-.4-.4-.6-.9-.7-1.4-.4.2-.9.3-1.4.3-2.6 0-5-2.8-5.9-4 1.1-1.5 3.5-4 5.9-4 2.6 0 5 2.8 5.9 4-.2.3-.5.7-.9 1.1.2.1.5.3.6.5l.9.9c.6-.6 1.1-1.3 1.6-1.9.2-.3.2-.8 0-1.1-.2-.2-3.6-5.5-8-5.5S.7 5.3.5 5.5c-.2.3-.2.8 0 1.1.2.3 3.6 5.5 8 5.5.8 0 1.7-.2 2.4-.5l-.4-.4z" }), external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("path", { className: styles["cls-1"] || "cls-1", d: "M16.2 14.9c-.4 0-.8-.2-1.1-.4l-3.8-3.8c-.6-.6-.5-1.6.1-2.1s1.5-.5 2 0l2.7 2.7 5-5c.6-.6 1.6-.5 2.1.1s.5 1.5 0 2l-6.1 6.1c-.2.2-.5.4-.9.4z" }));
});
// CONCATENATED MODULE: ./icons/images/indicators/Inspector.svg
var Inspector__extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function Inspector__objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}


/* harmony default export */ var Inspector = (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === undefined ? {} : _ref$styles,
      props = Inspector__objectWithoutProperties(_ref, ["styles"]);

  return external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("svg", Inspector__extends({ "data-name": "Layer 1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 35.5 10.4" }, props), external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("path", { className: styles["oc-icon-indicator"] || "oc-icon-indicator", d: "M34.5 1.5h-3.4a.9.9 0 0 0-.5.1 7.43 7.43 0 0 0-4.3-1.7 6.23 6.23 0 0 0-4.8 2.2A5.85 5.85 0 0 0 17.7.8 5.11 5.11 0 0 0 14 2.1a6 6 0 0 0-4.7-2A6.82 6.82 0 0 0 5 1.8c-.2-.1-.3-.2-.5-.1H1.2A1.13 1.13 0 0 0 0 2.8 1.08 1.08 0 0 0 1.1 4h2.5a2.66 2.66 0 0 0-.3 1.2c0 2.8 2.7 5.2 5.9 5.2s5.9-2.4 5.9-5.2a2.77 2.77 0 0 0-.1-.9 2.88 2.88 0 0 1 2.6-1.1 4.19 4.19 0 0 1 2.8 1 1.73 1.73 0 0 0-.1 1c0 2.8 2.7 5.2 5.9 5.2s5.9-2.4 5.9-5.2a5.85 5.85 0 0 0-.2-1.3h2.4a1.22 1.22 0 0 0 1.2-1.2 1.19 1.19 0 0 0-1-1.2zM9.3 8.1c-2 0-3.7-1.3-3.7-2.8s1.7-2.8 3.7-2.8S13 3.7 13 5.2s-1.7 2.9-3.7 2.9zm17.1 0c-2 0-3.7-1.3-3.7-2.8s1.7-2.8 3.7-2.8S30 3.7 30 5.2s-1.6 2.9-3.6 2.9z" }));
});
// CONCATENATED MODULE: ./icons/images/indicators/Logout.svg
var Logout__extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function Logout__objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}


/* harmony default export */ var Logout = (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === undefined ? {} : _ref$styles,
      props = Logout__objectWithoutProperties(_ref, ["styles"]);

  return external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("svg", Logout__extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 19 19" }, props), external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("path", { className: styles["oc-icon-indicator"] || "oc-icon-indicator", d: "M9.5 18.9c-2.5 0-4.8-1-6.5-2.7S.3 12.1.3 9.7c0-2.5 1-4.8 2.7-6.5.5-.7 1.5-.7 2.1-.1s.6 1.5 0 2.1C3.9 6.4 3.3 8 3.3 9.6c0 1.7.7 3.2 1.8 4.4 1.2 1.2 2.8 1.8 4.4 1.8s3.2-.7 4.4-1.8c1.2-1.2 1.8-2.8 1.8-4.4 0-1.7-.7-3.2-1.8-4.4-.6-.6-.6-1.5 0-2.1s1.5-.6 2.1 0c1.7 1.7 2.7 4.1 2.7 6.5 0 2.5-1 4.8-2.7 6.5-1.7 1.8-4 2.8-6.5 2.8z" }), external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("path", { className: styles["oc-icon-indicator"] || "oc-icon-indicator", d: "M9.5 11.1c-.8 0-1.5-.7-1.5-1.5v-8C8 .8 8.7.1 9.5.1S11 .8 11 1.6v8c0 .9-.7 1.5-1.5 1.5z" }));
});
// CONCATENATED MODULE: ./icons/images/indicators/Matched.svg
var Matched__extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function Matched__objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}


/* harmony default export */ var Matched = (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === undefined ? {} : _ref$styles,
      props = Matched__objectWithoutProperties(_ref, ["styles"]);

  return external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("svg", Matched__extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 15 15" }, props), external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("path", { className: (styles["oc-icon-indicator"] || "oc-icon-indicator") + " " + (styles["oc-icon-status-success"] || "oc-icon-status-success"), d: "M9.6 5.4c1.8 1.8 1.7 4.6 0 6.3l-2 2c-1.7 1.7-4.6 1.7-6.3 0-1.7-1.7-1.7-4.6 0-6.3l1.1-1.1c.3-.3.8-.1.8.3 0 .5.1 1 .3 1.5.1.2 0 .4-.1.5L3 9c-.8.8-.8 2.2 0 3 .8.8 2.2.8 3 0l2-2c.8-.8.8-2.2 0-3-.2 0-.3-.1-.4-.2-.1 0-.2-.2-.2-.3 0-.3.1-.6.3-.9l.7-.6c.1-.2.4-.2.6-.1.2.2.4.3.6.5zm4.1-4.1C12-.4 9.1-.4 7.4 1.3l-2 2C3.7 5 3.7 7.8 5.4 9.6c.2.2.4.3.6.5.2.1.4.1.6-.1l.6-.6c.2-.2.4-.6.3-.9 0-.1-.1-.3-.2-.4l-.2-.2c-.8-.8-.8-2.2 0-3l2-2c.8-.8 2.2-.8 3 0 .8.8.8 2.2 0 3l-.4.4c-.1.1-.2.3-.1.5.2.5.3 1 .3 1.5 0 .4.5.6.8.3l1.1-1.1c1.6-1.6 1.6-4.5-.1-6.2z" }));
});
// CONCATENATED MODULE: ./icons/images/indicators/Minus.svg
var Minus__extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function Minus__objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}


/* harmony default export */ var Minus = (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === undefined ? {} : _ref$styles,
      props = Minus__objectWithoutProperties(_ref, ["styles"]);

  return external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("svg", Minus__extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 13 4" }, props), external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("path", { className: styles["oc-icon-indicator"] || "oc-icon-indicator", d: "M.9.5h11.2c.4 0 .7.3.7.7v1.6c0 .4-.3.7-.7.7H.9c-.4 0-.7-.3-.7-.7V1.2C.2.8.5.5.9.5z" }));
});
// CONCATENATED MODULE: ./icons/images/indicators/More.svg
var More__extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function More__objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}


/* harmony default export */ var More = (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === undefined ? {} : _ref$styles,
      props = More__objectWithoutProperties(_ref, ["styles"]);

  return external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("svg", More__extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 19 5" }, props), external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("circle", { className: styles["oc-icon-indicator"] || "oc-icon-indicator", cx: "2.5", cy: "2.5", r: "2.3" }), external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("circle", { className: styles["oc-icon-indicator"] || "oc-icon-indicator", cx: "9.5", cy: "2.5", r: "2.3" }), external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("circle", { className: styles["oc-icon-indicator"] || "oc-icon-indicator", cx: "16.5", cy: "2.5", r: "2.3" }));
});
// CONCATENATED MODULE: ./icons/images/indicators/Ok.svg
var Ok__extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function Ok__objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}


/* harmony default export */ var Ok = (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === undefined ? {} : _ref$styles,
      props = Ok__objectWithoutProperties(_ref, ["styles"]);

  return external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("svg", Ok__extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 17 13" }, props), external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("path", { className: (styles["oc-icon-indicator"] || "oc-icon-indicator") + " " + (styles["oc-icon-status-success"] || "oc-icon-status-success"), d: "M7.2 12.5c-.3 0-.7-.1-.9-.3L1 7.9C.3 7.4.2 6.5.6 5.8S2 5 2.7 5.4c.1 0 .1.1.2.1l4.2 3.4 7-7.9c.6-.6 1.5-.7 2.1-.1.6.6.7 1.5.1 2.1l-8 9c-.3.3-.7.5-1.1.5z" }));
});
// CONCATENATED MODULE: ./icons/images/indicators/Pinned.svg
var Pinned__extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function Pinned__objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}


/* harmony default export */ var Pinned = (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === undefined ? {} : _ref$styles,
      props = Pinned__objectWithoutProperties(_ref, ["styles"]);

  return external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("svg", Pinned__extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 14 18" }, props), external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("path", { className: styles["oc-icon-indicator"] || "oc-icon-indicator", d: "M11.2 8.6h-.8V2.9c.7-.1 1.3-.7 1.2-1.5C11.5.7 11 .2 10.4.2H3.6c-.7 0-1.4.6-1.4 1.3 0 .7.6 1.4 1.3 1.4v5.7h-.7C1.4 8.6.3 10 .3 11.7h5.6l.7 6h.7l.8-6h5.5c.1-1.7-1.1-3.1-2.4-3.1zm-5.3 0h-.5V2.9h.5v5.7z" }));
});
// CONCATENATED MODULE: ./icons/images/indicators/Plus.svg
var Plus__extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function Plus__objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}


/* harmony default export */ var Plus = (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === undefined ? {} : _ref$styles,
      props = Plus__objectWithoutProperties(_ref, ["styles"]);

  return external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("svg", Plus__extends({ "data-name": "Layer 1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 9 9" }, props), external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("path", { className: styles["oc-icon-indicator"] || "oc-icon-indicator", d: "M9 4.5a.91.91 0 0 1-.91.91H5.41v2.68a.91.91 0 0 1-1.82 0V5.41H.91a.91.91 0 0 1 0-1.82h2.68V.91a.91.91 0 0 1 1.82 0v2.68h2.68A.91.91 0 0 1 9 4.5z" }));
});
// CONCATENATED MODULE: ./icons/images/indicators/Presentation.svg
var Presentation__extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function Presentation__objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}


/* harmony default export */ var Presentation = (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === undefined ? {} : _ref$styles,
      props = Presentation__objectWithoutProperties(_ref, ["styles"]);

  return external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("svg", Presentation__extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 19 16" }, props), external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("path", { className: styles["oc-icon-indicator"] || "oc-icon-indicator", d: "M.3.2V12h18.3V.2H.3zm7.1 8.9V3.6l4.8 2.8-4.8 2.7z" }), external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("path", { className: styles["oc-icon-indicator"] || "oc-icon-indicator", d: "M13.5 15.8l-4-5-4 5z" }));
});
// CONCATENATED MODULE: ./icons/images/indicators/Print.svg
var Print__extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function Print__objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}


/* harmony default export */ var Print = (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === undefined ? {} : _ref$styles,
      props = Print__objectWithoutProperties(_ref, ["styles"]);

  return external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("svg", Print__extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 19 17" }, props), external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("path", { className: styles["oc-icon-indicator"] || "oc-icon-indicator", d: "M16.7 3.5H2.3c-1.1 0-2 .9-2 2V11c0 1.1.9 2 2 2h2.4v4h10v-4h1.9c1.1 0 2-.9 2-2V5.5c.1-1.1-.8-2-1.9-2zM12.8 15h-6v-2h6v2zM4.8 0h10v2h-10z" }));
});
// CONCATENATED MODULE: ./icons/images/indicators/Rejected.svg
var Rejected__extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function Rejected__objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}


/* harmony default export */ var Rejected = (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === undefined ? {} : _ref$styles,
      props = Rejected__objectWithoutProperties(_ref, ["styles"]);

  return external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("svg", Rejected__extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 15 15" }, props), external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("path", { className: styles["oc-icon-indicator"] || "oc-icon-indicator", d: "M7.5 0C3.4 0 0 3.4 0 7.5S3.4 15 7.5 15 15 11.6 15 7.5 11.6 0 7.5 0zm4.4 9H3.1V6h8.7l.1 3z" }));
});
// CONCATENATED MODULE: ./icons/images/indicators/Remove.svg
var Remove__extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function Remove__objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}


/* harmony default export */ var Remove = (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === undefined ? {} : _ref$styles,
      props = Remove__objectWithoutProperties(_ref, ["styles"]);

  return external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("svg", Remove__extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16" }, props), external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("path", { className: (styles["oc-icon-indicator"] || "oc-icon-indicator") + " " + (styles["oc-icon-remove"] || "oc-icon-remove"), d: "M10.3 8l5-5c.6-.6.6-1.7 0-2.3-.6-.7-1.7-.7-2.3 0l-5 5-5-5C2.4 0 1.3 0 .7.7 0 1.3 0 2.4.7 3l5 5-5 5c-.6.6-.6 1.7 0 2.3s1.7.6 2.3 0l5-5 5 5c.6.6 1.7.6 2.3 0s.6-1.7 0-2.3l-5-5z" }));
});
// CONCATENATED MODULE: ./icons/images/indicators/RemoveFilter.svg
var RemoveFilter__extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function RemoveFilter__objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}


/* harmony default export */ var RemoveFilter = (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === undefined ? {} : _ref$styles,
      props = RemoveFilter__objectWithoutProperties(_ref, ["styles"]);

  return external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("svg", RemoveFilter__extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 21 19" }, props), external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("path", { className: styles["oc-icon-indicator"] || "oc-icon-indicator", d: "M21 .2H0l8.6 11.1-.2 5 3.4 2.5.1-7.4z" }), external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("path", { className: styles["oc-icon-indicator"] || "oc-icon-indicator", d: "M18.4 14.8l2.3-2.3c.3-.3.3-.8 0-1.1s-.8-.3-1.1 0l-2.3 2.3-2.3-2.3c-.3-.3-.8-.3-1.1 0-.3.3-.3.8 0 1.1l2.3 2.3-2.3 2.3c-.3.3-.3.8 0 1.1.3.3.8.3 1.1 0l2.3-2.3 2.3 2.3c.3.3.8.3 1.1 0 .3-.3.3-.8 0-1.1l-2.3-2.3z" }));
});
// CONCATENATED MODULE: ./icons/images/indicators/Save.svg
var Save__extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function Save__objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}


/* harmony default export */ var Save = (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === undefined ? {} : _ref$styles,
      props = Save__objectWithoutProperties(_ref, ["styles"]);

  return external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("svg", Save__extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 17 17" }, props), external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("path", { className: styles["oc-icon-indicator"] || "oc-icon-indicator", d: "M14 0H0v17h17V3.6L14 0zM6.9 2h3.9v5.8H6.9V2zm8 13h-13V2h1.5v7.4h9.5V2h.1l2 2.3-.1 10.7z" }));
});
// CONCATENATED MODULE: ./icons/images/indicators/Search.svg
var Search__extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function Search__objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}


/* harmony default export */ var Search = (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === undefined ? {} : _ref$styles,
      props = Search__objectWithoutProperties(_ref, ["styles"]);

  return external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("svg", Search__extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16" }, props), external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("path", { className: styles["oc-icon-indicator"] || "oc-icon-indicator", d: "M15.7 14.3L11.4 10c2-2.8 1.4-6.7-1.4-8.7S3.3-.1 1.2 2.7s-1.4 6.7 1.4 8.7c2.2 1.6 5.1 1.6 7.3 0l4.3 4.3c.4.4 1.1.3 1.4-.1.4-.4.4-.9.1-1.3zm-12.4-5c-1.6-1.6-1.6-4.3 0-6s4.3-1.6 6 0 1.6 4.3 0 6c-.8.8-1.8 1.2-3 1.2-1.1 0-2.2-.4-3-1.2z" }));
});
// CONCATENATED MODULE: ./icons/images/indicators/SearchWithCircle.svg
var SearchWithCircle__extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function SearchWithCircle__objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}


/* harmony default export */ var SearchWithCircle = (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === undefined ? {} : _ref$styles,
      props = SearchWithCircle__objectWithoutProperties(_ref, ["styles"]);

  return external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("svg", SearchWithCircle__extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20" }, props), external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("path", { className: styles["oc-icon-indicator"] || "oc-icon-indicator", d: "M10 0c5.5 0 10 4.5 10 10s-4.5 10-10 10S0 15.5 0 10 4.5 0 10 0zm5.5 14.5l-3.1-3.1c.6-.7.8-1.7.8-2.6 0-2.4-2-4.4-4.4-4.4s-4.4 2-4.4 4.4c0 2.4 2 4.4 4.4 4.4.9 0 1.8-.3 2.6-.8l3.1 3.1c.1.1.3.2.5.2s.4-.1.5-.2c.3-.2.3-.7 0-1zM6.7 11c-1.2-1.2-1.2-3.1 0-4.2.6-.6 1.3-.9 2.1-.9 1.7 0 3 1.3 3 3s-1.3 3-3 3c-.7 0-1.5-.4-2.1-.9z" }));
});
// CONCATENATED MODULE: ./icons/images/indicators/Settings.svg
var Settings__extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function Settings__objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}


/* harmony default export */ var Settings = (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === undefined ? {} : _ref$styles,
      props = Settings__objectWithoutProperties(_ref, ["styles"]);

  return external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("svg", Settings__extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 21" }, props), external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("path", { className: styles["oc-icon-indicator"] || "oc-icon-indicator", d: "M18.2 12.4c-1-1.8-.4-4.1 1.4-5.2l-2-3.4c-.6.3-1.2.5-1.9.5-2 .1-3.6-1.4-3.7-3.4V.4H8c0 .7-.1 1.4-.5 1.9-1 1.8-3.3 2.4-5.1 1.4l-2 3.4c.6.5 1 1 1.4 1.5 1 1.8.4 4.1-1.4 5.2l2 3.4c.6-.2 1.2-.4 1.9-.4 2 .1 3.6 1.8 3.7 3.8h3.9c0-.7.1-1.3.5-1.9 1.1-1.8 3.4-2.4 5.2-1.4l2-3.4c-.6-.3-1-.8-1.4-1.5zM10 14.7c-2.2 0-4-1.8-4-4s1.8-4 4-4 4 1.8 4 4-1.8 4-4 4z" }));
});
// CONCATENATED MODULE: ./icons/images/indicators/SortAsc.svg
var SortAsc__extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function SortAsc__objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}


/* harmony default export */ var SortAsc = (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === undefined ? {} : _ref$styles,
      props = SortAsc__objectWithoutProperties(_ref, ["styles"]);

  return external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("svg", SortAsc__extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 7 10" }, props), external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("path", { className: styles["oc-icon-indicator"] || "oc-icon-indicator", d: "M6.6 4.9L3.5.4.4 4.9h2.1v4.7h1.9V4.9z" }));
});
// CONCATENATED MODULE: ./icons/images/indicators/SortDesc.svg
var SortDesc__extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function SortDesc__objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}


/* harmony default export */ var SortDesc = (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === undefined ? {} : _ref$styles,
      props = SortDesc__objectWithoutProperties(_ref, ["styles"]);

  return external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("svg", SortDesc__extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 7 10" }, props), external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("path", { className: styles["oc-icon-indicator"] || "oc-icon-indicator", d: "M.4 5.1l3.1 4.5 3.1-4.5H4.5V.4H2.6v4.7z" }));
});
// CONCATENATED MODULE: ./icons/images/indicators/StatusInclarification.svg
var StatusInclarification__extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function StatusInclarification__objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}


/* harmony default export */ var StatusInclarification = (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === undefined ? {} : _ref$styles,
      props = StatusInclarification__objectWithoutProperties(_ref, ["styles"]);

  return external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("svg", StatusInclarification__extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 11 19" }, props), external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("path", { className: styles["oc-icon-indicator"] || "oc-icon-indicator", d: "M.4 2.1c.3-.3.6-.5 1-.7L2.6.8C3 .6 3.5.4 3.9.4c.5-.1 1-.1 1.6-.1.7 0 1.4.1 2.1.3.6.1 1.2.4 1.6.8.4.4.8.9 1 1.4.2.6.4 1.2.4 1.8 0 .6-.1 1.1-.3 1.6-.2.4-.4.8-.7 1.2-.2.4-.5.7-.8.9l-.9.7c-.3.2-.6.4-.8.7-.2.2-.3.4-.4.7l-.4 1.8H3.7l-.3-2v-.1-.1c0-.4.1-.7.3-1 .2-.3.4-.5.7-.8.3-.2.6-.5.9-.7.2-.3.5-.5.8-.8.3-.2.5-.5.7-.8.1-.3.2-.7.2-1.1 0-.4-.2-.8-.5-1.1-.4-.3-.9-.5-1.4-.5-.4 0-.7 0-1.1.1-.2.1-.5.2-.7.4l-.6.3c-.1.1-.3.1-.5.1-.3 0-.6-.1-.8-.4l-1-1.6zm2.3 14.6c0-.3.1-.6.2-.8.1-.3.3-.5.5-.7.1-.2.4-.4.6-.5.3-.1.6-.2.9-.2.3 0 .6.1.9.2.2.1.5.3.7.5.4.4.6.9.6 1.5 0 .3-.1.6-.2.8-.1.3-.3.5-.5.7-.2.2-.4.3-.7.5-.3.1-.6.2-.9.2-.3 0-.6-.1-.9-.2-.7-.4-1.2-1.2-1.2-2z" }));
});
// CONCATENATED MODULE: ./icons/images/indicators/StatusLocked.svg
var StatusLocked__extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function StatusLocked__objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}


/* harmony default export */ var StatusLocked = (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === undefined ? {} : _ref$styles,
      props = StatusLocked__objectWithoutProperties(_ref, ["styles"]);

  return external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("svg", StatusLocked__extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 21" }, props), external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("path", { className: (styles["oc-icon-indicator"] || "oc-icon-indicator") + " " + (styles["oc-icon-status-attention"] || "oc-icon-status-attention"), d: "M14.1 7.7c0-4.8 0-7.4-6.1-7.4S1.9 2.9 1.9 7.7H.2v13h15.6v-13h-1.7zM8 2.9c3.5 0 3.5.1 3.5 4.8h-7c0-4.8 0-4.8 3.5-4.8zm.8 11.5v2.3c0 .4-.3.8-.7.8s-.8-.3-.8-.7v-2.5c-1-.3-1.3-1.3-.9-2.2s1.5-1.3 2.4-.9c.9.4 1.3 1.5.9 2.4-.3.3-.6.6-.9.8z" }));
});
// CONCATENATED MODULE: ./icons/images/indicators/StatusUser.svg
var StatusUser__extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function StatusUser__objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}


/* harmony default export */ var StatusUser = (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === undefined ? {} : _ref$styles,
      props = StatusUser__objectWithoutProperties(_ref, ["styles"]);

  return external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("svg", StatusUser__extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 19" }, props), external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("path", { className: styles["oc-icon-indicator"] || "oc-icon-indicator", d: "M8 0c2.8 0 5.1 1.8 5.1 5.2s-2.9 7.4-5.1 7.4-5.1-3.9-5.1-7.4S5.2 0 8 0z" }), external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("path", { className: styles["oc-icon-indicator"] || "oc-icon-indicator", d: "M.3 16.6c0-2.1 1.9-3.6 4.7-4.2.7 1 1.8 1.6 3 1.8 1.2-.2 2.3-.8 3-1.8 2.7.6 4.7 2 4.7 4.2.1 3.2-15.4 3.2-15.4 0z" }));
});
// CONCATENATED MODULE: ./icons/images/indicators/Unmatched.svg
var Unmatched__extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function Unmatched__objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}


/* harmony default export */ var Unmatched = (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === undefined ? {} : _ref$styles,
      props = Unmatched__objectWithoutProperties(_ref, ["styles"]);

  return external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("svg", Unmatched__extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 15 15" }, props), external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("path", { className: (styles["oc-icon-indicator"] || "oc-icon-indicator") + " " + (styles["oc-icon-status-error"] || "oc-icon-status-error"), d: "M8.9 11.9c.1.1.1.4 0 .5l-1.3 1.3c-1.7 1.7-4.6 1.7-6.3 0-1.7-1.7-1.7-4.6 0-6.3l1.3-1.3c.1-.1.4-.1.5 0l1.2 1.2c.1.1.1.4 0 .5L3 9.1c-.8.8-.8 2.2 0 3 .8.8 2.2.8 3 0l1.3-1.3c.1-.1.4-.1.5 0l1.1 1.1zM7.3 4.3c.1.1.4.1.5 0L9.1 3c.8-.8 2.2-.8 3 0 .8.8.8 2.2 0 3l-1.3 1.3c-.1.1-.1.4 0 .5L12 9s.3 0 .4-.1l1.3-1.3c1.7-1.7 1.7-4.6 0-6.3C12-.4 9.1-.4 7.4 1.3L6.1 2.6c-.1.1-.1.4 0 .5l1.2 1.2zm6.8 10.5l.7-.7c.3-.3.3-.7 0-1L1.9.2c-.3-.3-.7-.3-1 0L.2.9c-.3.3-.3.7 0 1l12.9 12.9c.3.3.8.3 1 0z" }));
});
// CONCATENATED MODULE: ./icons/images/indicators/ConfirmedSub.svg
var ConfirmedSub__extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function ConfirmedSub__objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}


/* harmony default export */ var ConfirmedSub = (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === undefined ? {} : _ref$styles,
      props = ConfirmedSub__objectWithoutProperties(_ref, ["styles"]);

  return external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("svg", ConfirmedSub__extends({ "data-name": "Layer 1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 25 20" }, props), external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("path", { className: (styles["oc-icon-indicator"] || "oc-icon-indicator") + " " + (styles["oc-icon-status-success"] || "oc-icon-status-success"), d: "M20 9.06a10 10 0 1 0-3 8.06L18.68 20 25 9.06zM8.78 15.39a.55.55 0 0 1-.62.11.57.57 0 0 1-.16-.13l-4.36-4.31a.54.54 0 0 1 0-.78l1.05-1a.54.54 0 0 1 .78 0l2.89 2.89L14.52 6a.53.53 0 0 1 .77 0l1.07 1a.54.54 0 0 1 0 .78zm9.88.9l-3.17-5.49h6.34z" }));
});
// CONCATENATED MODULE: ./icons/images/indicators/PartiallySub.svg
var PartiallySub__extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function PartiallySub__objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}


/* harmony default export */ var PartiallySub = (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === undefined ? {} : _ref$styles,
      props = PartiallySub__objectWithoutProperties(_ref, ["styles"]);

  return external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("svg", PartiallySub__extends({ "data-name": "Layer 1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 25 20" }, props), external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("path", { className: (styles["oc-icon-indicator"] || "oc-icon-indicator") + " " + (styles["oc-icon-status-warning"] || "oc-icon-status-warning"), d: "M20 9.06a10 10 0 1 0-3 8.06L18.68 20 25 9.06zm-1.29 7.23l-3.22-5.49h6.34z" }));
});
// CONCATENATED MODULE: ./icons/images/indicators/ErrorSub.svg
var ErrorSub__extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function ErrorSub__objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}


/* harmony default export */ var ErrorSub = (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === undefined ? {} : _ref$styles,
      props = ErrorSub__objectWithoutProperties(_ref, ["styles"]);

  return external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("svg", ErrorSub__extends({ "data-name": "Layer 1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 25 20" }, props), external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("path", { className: (styles["oc-icon-indicator"] || "oc-icon-indicator") + " " + (styles["oc-icon-status-error"] || "oc-icon-status-error"), d: "M20 9.12V5.9L14.2 0H5.9L0 5.9v8.2L5.9 20h8.2l2.9-2.85 1.68 2.91L25 9.12zM8.5 6.1a1.3 1.3 0 1 1 2.6 0v4a1.3 1.3 0 1 1-2.6 0zm2.9 8.6a1.53 1.53 0 0 1-1.7 1.5 1.53 1.53 0 0 1-1.5-1.7A1.7 1.7 0 0 1 9.7 13a1.64 1.64 0 0 1 1.7 1.5c.1.1.1.1 0 .2zm4.12-3.78h6.34l-3.17 5.5z" }));
});
// CONCATENATED MODULE: ./icons/images/indicators/Warning.svg
var Warning__extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function Warning__objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}


/* harmony default export */ var Warning = (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === undefined ? {} : _ref$styles,
      props = Warning__objectWithoutProperties(_ref, ["styles"]);

  return external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("svg", Warning__extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 21 17" }, props), external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("path", { className: (styles["oc-icon-indicator"] || "oc-icon-indicator") + " " + (styles["oc-icon-status-warning"] || "oc-icon-status-warning"), d: "M20.1 14L12.3 1.3c-1-1.6-2.6-1.6-3.6 0L.9 14c-1 1.6-.2 3 1.7 3h15.8c1.9 0 2.7-1.4 1.7-3zM9.2 5.8c-.1-.6.4-1.2 1-1.2.6-.1 1.2.4 1.2 1v3.6c.1.6-.4 1.2-1 1.2-.6.1-1.2-.4-1.2-1V5.8zm1.1 8.4c-.7 0-1.3-.6-1.3-1.4 0-.7.6-1.3 1.4-1.3.7 0 1.3.6 1.3 1.3 0 .8-.6 1.4-1.4 1.4z" }));
});
// CONCATENATED MODULE: ./icons/images/indicators/ExceedsLimit.svg
var ExceedsLimit__extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function ExceedsLimit__objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}


/* harmony default export */ var ExceedsLimit = (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === undefined ? {} : _ref$styles,
      props = ExceedsLimit__objectWithoutProperties(_ref, ["styles"]);

  return external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("svg", ExceedsLimit__extends({ className: (styles["oc-icon-indicator"] || "oc-icon-indicator") + " " + (styles["oc-icon-status-error"] || "oc-icon-status-error"), xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16" }, props), external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("path", { className: (styles["oc-icon-indicator"] || "oc-icon-indicator") + " " + (styles["oc-icon-status-error"] || "oc-icon-status-error"), d: "M8 0C3.58 0 0 3.58 0 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zm3.06 10.62c-.13.35-.33.67-.59.94-.26.27-.58.49-.95.66s-.81.27-1.29.31l-.08.96a.48.48 0 0 1-.13.28c-.08.08-.18.13-.31.13h-.59l.12-1.39c-.51-.07-.98-.21-1.43-.42s-.82-.47-1.13-.77l.49-.74c.04-.07.1-.12.17-.16.07-.04.15-.06.22-.06.1 0 .2.03.31.1.11.07.23.15.37.24.14.09.3.18.47.27s.39.16.63.2l.26-2.93a9.94 9.94 0 0 1-.92-.31c-.3-.12-.57-.27-.81-.47s-.43-.43-.58-.73c-.15-.3-.22-.67-.22-1.11 0-.33.07-.65.2-.97.13-.31.32-.6.58-.84.24-.25.55-.45.92-.61.37-.16.79-.24 1.27-.24l.07-.83c.01-.1.05-.2.13-.28.08-.08.18-.13.31-.13h.59L9.03 3c.46.07.86.2 1.19.39.33.19.62.4.87.63l-.39.59c-.06.09-.12.15-.18.19a.38.38 0 0 1-.22.06c-.06 0-.14-.02-.23-.06-.1-.03-.2-.08-.31-.14-.12-.06-.24-.12-.38-.18s-.3-.11-.46-.15l-.23 2.69c.31.1.62.2.92.32.31.12.58.26.83.45.24.18.44.41.59.68.15.27.23.61.23 1.02 0 .39-.06.77-.2 1.13z" }), external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("path", { fill: "#DD2515", d: "M9.41 8.97c-.11-.1-.23-.18-.38-.25s-.3-.13-.47-.19l-.22 2.64c.46-.06.81-.21 1.04-.46.24-.25.35-.58.35-.98 0-.17-.03-.31-.09-.43a.856.856 0 0 0-.23-.33zM6.89 4.72c-.11.1-.19.22-.24.35s-.07.26-.07.41c0 .16.03.31.08.44.06.12.14.23.24.33.1.1.22.18.36.26.14.07.3.14.46.2l.2-2.41c-.24.04-.44.09-.61.16-.17.07-.31.16-.42.26z" }));
});
// CONCATENATED MODULE: ./icons/images/indicators/Confirmed.svg
var Confirmed__extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function Confirmed__objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}


/* harmony default export */ var Confirmed = (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === undefined ? {} : _ref$styles,
      props = Confirmed__objectWithoutProperties(_ref, ["styles"]);

  return external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("svg", Confirmed__extends({ "data-name": "Layer 1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 25 20" }, props), external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("title", null, "AccountsConfirmed"), external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("path", { className: (styles["oc-icon-indicator"] || "oc-icon-indicator") + " " + (styles["oc-icon-status-success"] || "oc-icon-status-success"), d: "M20.05 10a10 10 0 1 1-10-10 10.09 10.09 0 0 1 10 10zm-11.2 5.3l7.4-7.4a.56.56 0 0 0 0-.9l-.9-.9a.56.56 0 0 0-.9 0l-6 6-2.8-2.8a.56.56 0 0 0-.9 0l-.9.9a.56.56 0 0 0 0 .9l4.2 4.2a.47.47 0 0 0 .8 0z" }));
});
// CONCATENATED MODULE: ./icons/images/indicators/ErrorSmall.svg
var ErrorSmall__extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function ErrorSmall__objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}


/* harmony default export */ var ErrorSmall = (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === undefined ? {} : _ref$styles,
      props = ErrorSmall__objectWithoutProperties(_ref, ["styles"]);

  return external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("svg", ErrorSmall__extends({ "data-name": "Layer 1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 25 20" }, props), external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("title", null, "AccountsError"), external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("path", { className: (styles["oc-icon-indicator"] || "oc-icon-indicator") + " " + (styles["oc-icon-status-error"] || "oc-icon-status-error"), d: "M20.05 5.9v8.3l-5.9 5.8H6L.05 14.1V5.9L6 0h8.3zm-11.5 4.2a1.3 1.3 0 0 0 2.6 0v-4a1.3 1.3 0 0 0-2.6 0zm2.9 4.4a1.64 1.64 0 0 0-1.7-1.5 1.7 1.7 0 0 0-1.5 1.5 1.53 1.53 0 0 0 1.5 1.7 1.53 1.53 0 0 0 1.7-1.5c.1-.1.1-.1 0-.2z" }));
});
// CONCATENATED MODULE: ./icons/images/indicators/NotStarted.svg
var NotStarted__extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function NotStarted__objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}


/* harmony default export */ var NotStarted = (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === undefined ? {} : _ref$styles,
      props = NotStarted__objectWithoutProperties(_ref, ["styles"]);

  return external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("svg", NotStarted__extends({ "data-name": "Layer 1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 25 20" }, props), external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("title", null, "AccountsNotStarted"), external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("path", { className: (styles["oc-icon-indicator"] || "oc-icon-indicator") + " " + (styles["oc-icon-light-gray"] || "oc-icon-light-gray"), d: "M10.05 0a10 10 0 1 1-10 10 10 10 0 0 1 10-10z" }));
});
// CONCATENATED MODULE: ./icons/images/indicators/Partially.svg
var Partially__extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function Partially__objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}


/* harmony default export */ var Partially = (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === undefined ? {} : _ref$styles,
      props = Partially__objectWithoutProperties(_ref, ["styles"]);

  return external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("svg", Partially__extends({ "data-name": "Layer 1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 25 20" }, props), external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("title", null, "AccountsPartially"), external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("path", { className: (styles["oc-icon-indicator"] || "oc-icon-indicator") + " " + (styles["oc-icon-status-warning"] || "oc-icon-status-warning"), d: "M10.05 0a10 10 0 1 1-10 10 10 10 0 0 1 10-10z" }));
});
// CONCATENATED MODULE: ./icons/images/indicators/Average.svg
var Average__extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function Average__objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}


/* harmony default export */ var Average = (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === undefined ? {} : _ref$styles,
      props = Average__objectWithoutProperties(_ref, ["styles"]);

  return external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("svg", Average__extends({ "data-name": "Layer 1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20" }, props), external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("title", null, "Average"), external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("path", { className: styles["oc-icon-indicator"] || "oc-icon-indicator", d: "M17.55 1.18v1.39a1.07 1.07 0 0 1-1.07 1.07H3.59a1.07 1.07 0 0 1-1.07-1.07V1.18A1.07 1.07 0 0 1 3.59.11h12.89a1.07 1.07 0 0 1 1.07 1.07zm-5 11.43l3.86-4.23a1 1 0 0 0-.07-1.46l-1.21-1.15a1 1 0 0 0-1.46.06L10 9.82l-3.64-4a1 1 0 0 0-1.43-.02L3.67 7a1 1 0 0 0-.06 1.46l3.86 4.19-4.13 4.49a1 1 0 0 0 .06 1.46l1.26 1.15a1 1 0 0 0 1.46-.06L10 15.4l4 4.26a1 1 0 0 0 1.46.06l1.26-1.16a1 1 0 0 0 .06-1.46z" }));
});
// CONCATENATED MODULE: ./icons/images/indicators/Last.svg
var Last__extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function Last__objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}


/* harmony default export */ var Last = (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === undefined ? {} : _ref$styles,
      props = Last__objectWithoutProperties(_ref, ["styles"]);

  return external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("svg", Last__extends({ "data-name": "Layer 1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20" }, props), external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("title", null, "Last"), external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("path", { className: styles["oc-icon-indicator"] || "oc-icon-indicator", d: "M18.94 17.89h-1.5a1 1 0 0 1-1-1V3.23a1 1 0 0 1 1-1h1.5a1 1 0 0 1 1 1v13.66a1 1 0 0 1-1 1zm-4.44-7.13a1 1 0 0 0 0-1.52l-6-5.16a1 1 0 0 0-1.65.76v3.41H1.06a1 1 0 0 0-1 1v1.5a1 1 0 0 0 1 1h5.78v3.41a1 1 0 0 0 1.65.76z" }));
});
// CONCATENATED MODULE: ./icons/images/indicators/Max.svg
var Max__extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function Max__objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}


/* harmony default export */ var Max = (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === undefined ? {} : _ref$styles,
      props = Max__objectWithoutProperties(_ref, ["styles"]);

  return external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("svg", Max__extends({ "data-name": "Layer 1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20" }, props), external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("title", null, "Max"), external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("path", { className: styles["oc-icon-indicator"] || "oc-icon-indicator", d: "M17.83 1.12v1.51a1 1 0 0 1-1 1H3.17a1 1 0 0 1-1-1V1.12a1 1 0 0 1 1-1h13.66a1 1 0 0 1 1 1zM10.7 5.56a1 1 0 0 0-1.52 0L4 11.57a1 1 0 0 0 .75 1.65h3.44V19a1 1 0 0 0 1 1h1.5a1 1 0 0 0 1-1v-5.78h3.41a1 1 0 0 0 .76-1.65z" }));
});
// CONCATENATED MODULE: ./icons/images/indicators/Min.svg
var Min__extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function Min__objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}


/* harmony default export */ var Min = (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === undefined ? {} : _ref$styles,
      props = Min__objectWithoutProperties(_ref, ["styles"]);

  return external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("svg", Min__extends({ "data-name": "Layer 1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20" }, props), external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("title", null, "Min"), external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("path", { className: styles["oc-icon-indicator"] || "oc-icon-indicator", d: "M2.17 19v-1.5a1 1 0 0 1 1-1h13.66a1 1 0 0 1 1 1V19a1 1 0 0 1-1 1H3.17a1 1 0 0 1-1-1zm7.13-4.43a1 1 0 0 0 1.52 0l5.16-6a1 1 0 0 0-.75-1.65h-3.42v-5.8a1 1 0 0 0-1-1h-1.5a1 1 0 0 0-1 1V6.9H4.9a1 1 0 0 0-.76 1.65z" }));
});
// CONCATENATED MODULE: ./icons/images/products/Invoices.svg
var Invoices__extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function Invoices__objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}


/* harmony default export */ var Invoices = (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === undefined ? {} : _ref$styles,
      props = Invoices__objectWithoutProperties(_ref, ["styles"]);

  return external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("svg", Invoices__extends({ viewBox: "0 0 40 40" }, props), external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("path", { className: styles["oc-icon-product"] || "oc-icon-product", d: "M23.9 6.9v6.3h6.5z" }), external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("path", { className: styles["oc-icon-product"] || "oc-icon-product", d: "M31.3 15v.1h-9.4V6.5H10.3v27h21V15zm-4.4 5.1L21 26.7c-.2.2-.5.4-.8.4-.2 0-.5-.1-.7-.2l-3.9-3.2c-.5-.4-.5-1.1-.2-1.6.4-.5 1.1-.6 1.6-.2l3.1 2.5 5.2-5.8c.4-.5 1.1-.5 1.6-.1.4.4.4 1.1 0 1.6z" }));
});
// CONCATENATED MODULE: ./icons/images/products/User.svg
var User__extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function User__objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}


/* harmony default export */ var User = (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === undefined ? {} : _ref$styles,
      props = User__objectWithoutProperties(_ref, ["styles"]);

  return external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("svg", User__extends({ viewBox: "0 0 40 40" }, props), external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("path", { className: styles["oc-icon-product"] || "oc-icon-product", d: "M20.3 6.1c-7.8 0-14.2 6.3-14.2 14.2 0 7.8 6.3 14.2 14.2 14.2 7.8 0 14.2-6.3 14.2-14.2-.1-7.9-6.4-14.2-14.2-14.2zm0 8.4c1.9 0 3.5 1.2 3.5 3.6 0 2.4-2 5.1-3.5 5.1s-3.5-2.7-3.5-5.1c-.1-2.4 1.5-3.6 3.5-3.6zm-5.4 12.2c0-3 1.3-2.9 3.2-3.3.6.7 1.4 1 2.1 1 .7 0 1.5-.3 2.1-1 1.9.4 3.2.2 3.2 3.2.1 2.1-10.6 2.1-10.6.1z" }));
});
// CONCATENATED MODULE: ./icons/images/products/Accounts.svg
var Accounts__extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function Accounts__objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}


/* harmony default export */ var Accounts = (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === undefined ? {} : _ref$styles,
      props = Accounts__objectWithoutProperties(_ref, ["styles"]);

  return external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("svg", Accounts__extends({ viewBox: "0 0 40 40" }, props), external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("path", { className: styles["oc-icon-product"] || "oc-icon-product", d: "M8.2 29.5h24.2v2.1H8.2z" }), external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("path", { className: styles["oc-icon-product"] || "oc-icon-product", d: "M6.8 31.5h27v2.1h-27zM10.8 17.9h3.7v9.4h-3.7zM18.4 17.9h3.7v9.4h-3.7zM26.1 17.9h3.7v9.4h-3.7zM20.3 6.2L8 16.2h24.6l-12.3-10zm0 7.4c-1.1 0-2.1-.9-2.1-2.1 0-1.1.9-2.1 2.1-2.1 1.1 0 2.1.9 2.1 2.1-.1 1.2-1 2.1-2.1 2.1z" }));
});
// CONCATENATED MODULE: ./icons/images/products/Archive.svg
var Archive__extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function Archive__objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}


/* harmony default export */ var Archive = (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === undefined ? {} : _ref$styles,
      props = Archive__objectWithoutProperties(_ref, ["styles"]);

  return external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("svg", Archive__extends({ viewBox: "0 0 40 40" }, props), external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("path", { className: styles["oc-icon-product"] || "oc-icon-product", d: "M27.1 9.6v21.3h7V9.6h-7zm3.5 18.2c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5 1.5.7 1.5 1.5-.7 1.5-1.5 1.5zM17.6 9.6v21.3h7V9.6h-7zm3.5 18.2c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5 1.5.7 1.5 1.5-.7 1.5-1.5 1.5z" }), external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("path", { className: styles["oc-icon-product"] || "oc-icon-product", d: "M11.4 9L5.2 29.5l6.7 2 6.2-20.4L11.4 9zm-2 18.4c-.8-.2-1.3-1.1-1-1.9.2-.8 1.1-1.3 1.9-1 .8.2 1.3 1.1 1 1.9-.2.8-1.1 1.3-1.9 1z" }));
});
// CONCATENATED MODULE: ./icons/images/products/Dashboard.svg
var Dashboard__extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function Dashboard__objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}


/* harmony default export */ var Dashboard = (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === undefined ? {} : _ref$styles,
      props = Dashboard__objectWithoutProperties(_ref, ["styles"]);

  return external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("svg", Dashboard__extends({ viewBox: "0 0 40 40" }, props), external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("path", { className: styles["oc-icon-product"] || "oc-icon-product", d: "M34.5 23.4c0-2-.4-4.4-1.1-6.2-.8-1.8-1.8-3.7-3-5S27.5 9.7 25.7 9c-1.8-.8-3.6-1.2-5.5-1.2s-3.8.4-5.5 1.2c-1.8.8-3.3 1.8-4.5 3.1s-2.3 2.9-3 4.7c-.7 1.8-1.1 3.7-1.1 5.7 0 2.9.8 5.5 2.3 7.9.2.3.5.5.9.5l22.2-.1c.4 0 .6.1.8-.2 1.4-2.5 2.2-4.2 2.2-7.2zm-14.4 4.3c-1.2 0-2.1-.8-2.1-1.7 0-.9 1.7-11.4 2.2-11.4.5 0 2 10.5 2 11.4 0 1-1 1.7-2.1 1.7zm11.4-4.3c-.6 0-1-.7-1-1.3 0-1.4-.3-2.9-.8-4.1-.6-1.3-1.3-2.5-2.2-3.4-.9-.9-2-1.7-3.3-2.2-1.3-.5-2.6-.8-4-.8s-2.7.3-4 .8c-1.2.6-2.3 1.3-3.2 2.2-.9.9-1.6 2-2.2 3.3-.5 1.3-.8 2.8-.8 4.2 0 .6-.4 1.3-1 1.3-.5 0-1-.7-1-1.2 0-1.7.3-3.4 1-4.9.6-1.5 1.5-2.9 2.6-4s2.4-2 3.9-2.7c1.5-.7 3.1-1 4.7-1 1.7 0 3.3.3 4.8.9 1.5.6 2.8 1.5 3.9 2.6s2 2.4 2.6 3.9c.7 1.5 1 3.4 1 5 0 .7-.4 1.4-1 1.4z" }));
});
// CONCATENATED MODULE: ./icons/images/products/Info.svg
var products_Info__extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function products_Info__objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}


/* harmony default export */ var products_Info = (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === undefined ? {} : _ref$styles,
      props = products_Info__objectWithoutProperties(_ref, ["styles"]);

  return external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("svg", products_Info__extends({ viewBox: "0 0 40 40" }, props), external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("path", { className: styles["oc-icon-product"] || "oc-icon-product", d: "M20.3 7.4c-7.1 0-12.9 5.8-12.9 12.9s5.8 12.9 12.9 12.9 12.9-5.8 12.9-12.9S27.4 7.4 20.3 7.4zm1.5 20.4h-3.1V17.4h3.1v10.4zm.2-12.5c-.1.2-.2.4-.4.6-.2.2-.4.3-.6.4s-.5.1-.7.1c-.3 0-.5 0-.7-.1-.2-.1-.4-.2-.6-.4-.2-.2-.3-.4-.4-.6s-.1-.4-.1-.7c0-.3 0-.5.1-.7s.2-.4.4-.6.4-.3.6-.4c.2-.1.5-.1.7-.1.3 0 .5 0 .7.1.2.1.4.2.6.4.2.2.3.4.4.6s.1.5.1.7c0 .2 0 .4-.1.7z" }));
});
// CONCATENATED MODULE: ./icons/images/products/Liquidity.svg
var Liquidity__extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function Liquidity__objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}


/* harmony default export */ var Liquidity = (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === undefined ? {} : _ref$styles,
      props = Liquidity__objectWithoutProperties(_ref, ["styles"]);

  return external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("svg", Liquidity__extends({ viewBox: "0 0 40 40" }, props), external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("path", { className: styles["oc-icon-product"] || "oc-icon-product", d: "M22.9 26.1c-.3 0-.5-.1-.7-.3l-4.1-4.1-4 4c-.4.4-1 .4-1.4 0s-.4-1 0-1.4l4.7-4.7c.2-.2.4-.3.7-.3.3 0 .5.1.7.3l4.1 4.1 4.4-4.4c.4-.4 1-.4 1.4 0s.4 1 0 1.4l-5.1 5.1c-.2.2-.4.3-.7.3z" }), external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("circle", { className: styles["oc-icon-product"] || "oc-icon-product", cx: "28", cy: "20.1", r: "2" }), external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("circle", { className: styles["oc-icon-product"] || "oc-icon-product", cx: "18.1", cy: "20.4", r: "2" }), external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("circle", { className: styles["oc-icon-product"] || "oc-icon-product", cx: "22.9", cy: "25.1", r: "2" }), external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("path", { className: styles["oc-icon-product"] || "oc-icon-product", d: "M29.7 33.7H9.2c-.8 0-1.5-.7-1.5-1.5v-22c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5v20.6h19c.8 0 1.5.7 1.5 1.5 0 .7-.7 1.4-1.5 1.4z" }));
});
// CONCATENATED MODULE: ./icons/images/products/Netting.svg
var Netting__extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function Netting__objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}


/* harmony default export */ var Netting = (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === undefined ? {} : _ref$styles,
      props = Netting__objectWithoutProperties(_ref, ["styles"]);

  return external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("svg", Netting__extends({ viewBox: "0 0 40 40" }, props), external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("ellipse", { transform: "rotate(-14.76 16.216 13.85)", className: styles["oc-icon-product"] || "oc-icon-product", cx: "16.2", cy: "13.9", rx: "5.3", ry: "5.3" }), external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("ellipse", { transform: "rotate(-14.76 29.87 25.67)", className: styles["oc-icon-product"] || "oc-icon-product", cx: "29.9", cy: "25.7", rx: "3.7", ry: "3.7" }), external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("ellipse", { transform: "rotate(-14.76 9.849 30.945)", className: styles["oc-icon-product"] || "oc-icon-product", cx: "9.8", cy: "30.9", rx: "3", ry: "3" }), external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("path", { className: styles["oc-icon-product"] || "oc-icon-product", d: "M13.9 32.6c-2.2 0-3.5-.3-3.6-.3l-.3-.1c-1-.5-1.7-2.6.4-9 2.3-7.3 5-9.4 5.1-9.5l.4-.3.5.2c.2.1 4.8 1.5 9.3 5.6 4.5 4.1 5.2 6.6 5.3 6.9l.2.6-.5.3c-.2.1-3.8 3.2-9.7 4.7-2.8.7-5.3.9-7.1.9zm-2.8-2.2c1.2.2 4.8.5 9.3-.7 4.2-1.1 7.2-3 8.4-3.9-.5-.9-1.6-2.8-4.5-5.3-3.3-3-6.7-4.5-8-5-.7.8-2.5 3.1-4.1 8.2-1.3 4.5-1.2 6.2-1.1 6.7z" }));
});
// CONCATENATED MODULE: ./icons/images/products/Payments.svg
var Payments__extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function Payments__objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}


/* harmony default export */ var Payments = (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === undefined ? {} : _ref$styles,
      props = Payments__objectWithoutProperties(_ref, ["styles"]);

  return external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("svg", Payments__extends({ viewBox: "0 0 40 40" }, props), external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("path", { className: styles["oc-icon-product"] || "oc-icon-product", d: "M20.3 7.4c-7.1 0-12.8 5.7-12.8 12.8 0 .7.1 1.4.2 2 2.9 0 5.1 1.5 5.1 3.4v.9c.1.1.3.2.4.3.1.1.1.1.1.2.9-.8 2.4-1.2 4-1.2 1.8 0 3.4.6 4.3 1.5 0-.3.3-.6.3-.9 0-.3-.1-1.1-.2-1.4-.1-.2-.2-.2-.4-.4-.2-.3-.2-.4-.2-.8-.1-.7.1-.9-.6-.8-.2 0-.3.1-.5 0-.2-.2 0-.3-.3-.4-.3-.1-1.2.5-1.6.6-.4 0-.5-.2-.9-.4-.9-.7-1.5-1.5-1.4-2.6 0-.6.1-1.1.5-1.5.3-.3.8-.4 1-.8.2-.3.3-.8.7-1 .3-.2.8-.1 1.2-.2.4-.2.7-.3 1.1-.2.4 0 .7-.1.9.2.3.4 0 .7.5 1 .4.2 1.2.2 1.6-.1.1-.1 1.4.4 1.5.4.7.3 1.1.8 1.4 1.5.3.7.5 1.3 1 2 .1.2.5.8.6.9.1.1.6-.1.8-.1-.2 1.2-1.7 1.8-1.9 3-.1.4.2.8.1 1.2-.1.4-.5.6-.7.9-.2.2-.5.5-.5.8 0 .2.1.4 0 .5-.1.2-.5.3-.6.5-.4.4-.7.8-1.3 1-.4.1-.8.2-1.2.2v1.2c0 .5-.2 1-.4 1.4 6.3-.8 11.1-6.2 11.1-12.7-.1-7.1-5.8-12.9-12.9-12.9zM11 15.7c-.2.2-1.3.7-1.2 1.1 0 0 .4-.2.4-.1 0 .3-.5.8-.7 1.1-.1.2-.3.5-.5.8-.3.7-.1 1.5-.4 2.1 0-1.2.3-2.5.7-3.7.3-.8.9-2.6 1.6-2.9 0 .1-.1.2-.1.3 0 .2.2.4.2.6.1.3.1.5 0 .7zm3.9-4.6c-.3.3-.5.6-.7.9-.2.3-.7.8-1.1.8-.3 0-.8-.1-.7-.3.8-.7.4-.4.2-.1 1-.9 2.2-1.7 3.5-2.2-.3.4-.8.5-1.2.9zM27.8 28c-.4.5-.9.6-.7-.2.1-.4.3-.8.6-1.1.3-.3.4-.4.6-.8v.3c.1.6-.1 1.4-.5 1.8zM17.6 13c.1-.2.2-.1.5 0 0-.3-.1-1.1.4-1 .2 0 .7.9.8 1-.4.3-.8.3-1.3.4v-.5c-.1.2-.3.3-.4.5-.1-.1-.2-.3 0-.4zm13.2 6.8c-.4-.4-.7-.5-1.3-.7-.4-.1-.8-.6-1.2-.6.1.2.2.6.4.8.2.2.5 0 .7.2.1.1.1.3.2.3.4.5 0 .6-.4.9-.3.2-.5.4-.9.6-1 .4-1-.5-1.4-1.2-.1-.2-1.4-2.1-1.4-2.1.3-.2.2.1.3-.2.1-.2-.1-.6 0-.9-.6.4-.7.4-1.2-.3-.3-.5-.2-.8.4-1 .4-.1 1.1.2 1.5 0 .7-.3-.7-.8-.7-.8 0-.1.3-.3.4-.4-.7-.1-1.3.2-1.7.8-.2.3.2.2-.3.5-.2.1-.4 0-.6.1-.4.1-.5.1-.2.5-.3-.3-.4-.7-.6-1-.3-.3-.9-.6-1.3-.8 0 .6.5.9.9 1.3h-.6c.1-.3-.7-.9-1-.9-.9-.1-1.3.8-1.9 1.3-.4.3-1.3.4-1.5-.1-.1-.2 0-.5 0-.7 0-.5 0-.4.4-.5.5-.2.9-.1 1.1-.7 0-.1-.2-.3 0-.5.1-.2.5-.2.7-.3.3-.2.5-.3.8-.6.4-.3.5-.5.9-.3.2.1.4.5.7.5.9.1.7-1 .4-1.4-.1.2-.4.7-.6.8-.6.2-.5-.5-.8-.7-.4-.3-.8.3-.6-.3.1-.3.4-.4.7-.5.4-.2.9-.4 1.3-.5.4-.1.8.1 1.2.1.5 0 1.1-.2 1.5.1.3.2.1.3.5.5.3.2.2 0 .5 0 .1 0 .2-.1.2-.1.1.1.3.2.4.3 1 .7 1.9 1.5 2.6 2.5 1.6 2 2.4 4.5 2.4 7.1v.7c-.1-.7-.3-1.3-.9-1.8z" }), external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("path", { className: styles["oc-icon-product"] || "oc-icon-product", d: "M16.8 27.7c2 0 3.7.6 3.7 1.4 0 .8-1.7 1.4-3.7 1.4s-3.7-.6-3.7-1.4c0-.8 1.7-1.4 3.7-1.4zM6.9 23.9c2 0 3.7.6 3.7 1.4 0 .8-1.7 1.4-3.7 1.4s-3.7-.6-3.7-1.4c.1-.8 1.7-1.4 3.7-1.4zM10.6 28s-.6 1.2-3.7 1.2S3.3 28 3.3 28v-1.3s1.1 1.2 3.7 1.2 3.7-1.2 3.7-1.2V28zM10.6 30.5s-.6 1.2-3.7 1.2-3.7-1.2-3.7-1.2v-1.3s1.1 1.2 3.7 1.2 3.7-1.2 3.7-1.2v1.3zM10.6 33s-.6 1.2-3.7 1.2S3.3 33 3.3 33v-1.3s1.1 1.2 3.7 1.2 3.7-1.2 3.7-1.2V33zM20.5 32s-.6 1.2-3.7 1.2-3.7-1.2-3.7-1.2v-1.3s1.1 1.2 3.7 1.2 3.7-1.2 3.7-1.2V32z" }));
});
// CONCATENATED MODULE: ./icons/images/products/Settings.svg
var products_Settings__extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function products_Settings__objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}


/* harmony default export */ var products_Settings = (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === undefined ? {} : _ref$styles,
      props = products_Settings__objectWithoutProperties(_ref, ["styles"]);

  return external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("svg", products_Settings__extends({ viewBox: "0 0 40 40" }, props), external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("path", { className: styles["oc-icon-product"] || "oc-icon-product", d: "M31 22.7c-1.4-2.4-.5-5.4 1.8-6.8l-2.6-4.4c-.7.4-1.6.7-2.5.7-2.7 0-5-.9-5-4.9h-5.1c0 1-.2 1.6-.7 2.4-1.4 2.4-4.4 3.1-6.8 1.8l-2.6 4.4c.7.4 1.4 1 1.8 1.8 1.4 2.4.5 5.4-1.8 6.8l2.6 4.4c.7-.4 1.6-.6 2.5-.6 2.7 0 4.9 3 5 5h5.1c0-1 .2-1.7.7-2.5 1.4-2.4 4.4-3.2 6.8-1.8l2.6-4.4c-.7-.5-1.3-1.1-1.8-1.9zm-10.7 2.7c-2.9 0-5.3-2.4-5.3-5.3s2.4-5.3 5.3-5.3 5.3 2.4 5.3 5.3-2.4 5.3-5.3 5.3z" }));
});
// CONCATENATED MODULE: ./icons/images/products/Tools.svg
var Tools__extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function Tools__objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}


/* harmony default export */ var Tools = (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === undefined ? {} : _ref$styles,
      props = Tools__objectWithoutProperties(_ref, ["styles"]);

  return external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("svg", Tools__extends({ viewBox: "0 0 40 40" }, props), external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("path", { className: styles["oc-icon-product"] || "oc-icon-product", d: "M13.3 32.7h.1c-1.8 0-3.1-.8-3.1-2.6V16.7h6v13.4c0 1.8-1.3 2.6-3 2.6zM13.4 8.3l-3.2 6.4h6.4zM28.6 8.7v6h-4.5v-6c-2.4.9-4 3.2-4 5.9 0 2.6 1.6 4.8 3.8 5.8v9.9c0 1.4 1.1 2.5 2.5 2.5s2.5-1.1 2.5-2.5v-9.9c2.2-1 3.8-3.2 3.8-5.8-.1-2.7-1.8-5-4.1-5.9z" }));
});
// CONCATENATED MODULE: ./icons/images/products/Users.svg
var Users__extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function Users__objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}


/* harmony default export */ var Users = (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === undefined ? {} : _ref$styles,
      props = Users__objectWithoutProperties(_ref, ["styles"]);

  return external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("svg", Users__extends({ viewBox: "0 0 40 40" }, props), external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("path", { className: styles["oc-icon-product"] || "oc-icon-product", d: "M20.3 6.3c-7.7 0-14 6.3-14 14s6.3 14 14 14 14-6.3 14-14c0-7.8-6.3-14-14-14zm2 10.3c1.9 0 3.5 1.2 3.5 3.6 0 2.4-2 5-3.5 5s-3.5-2.7-3.5-5c0-2.5 1.5-3.6 3.5-3.6zm-8.1-1.7c1.2 0 2.2.8 2.2 2.2 0 1.5-1.2 3.2-2.2 3.2-.9 0-2.2-1.7-2.2-3.2 0-1.5 1-2.2 2.2-2.2zM10.9 22c0-.9.8-1.6 2-1.8.4.4.9.8 1.3.8s.9-.3 1.3-.8c1.2.2 2 .9 2 1.8 0 1.3-6.6 1.3-6.6 0zm6.1 5.8c0-2 1.3-2.4 3.2-2.8.6.7 1.4 1.2 2.1 1.2.7 0 1.4-.6 2.1-1.3 1.9.4 3.2.9 3.2 2.9s-10.6 2-10.6 0z" }));
});
// CONCATENATED MODULE: ./icons/images/products/Matching.svg
var Matching__extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function Matching__objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}


/* harmony default export */ var Matching = (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === undefined ? {} : _ref$styles,
      props = Matching__objectWithoutProperties(_ref, ["styles"]);

  return external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("svg", Matching__extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 42 42" }, props), external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("g", { fill: "#ccc" }, external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("path", { d: "M37.5 12.55v4h-8.36v2.06l-8.48-4.1 8.48-4.1v2.14h8.36zM4.71 18.19v5.11h9.87v2.63l10.01-5.24-10.01-5.24v2.74H4.71zM37.5 25.11v4h-8.36v2.06l-8.48-4.1 8.48-4.1v2.14h8.36z" })));
});
// CONCATENATED MODULE: ./icons/images/products/Inspector.svg
var products_Inspector__extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function products_Inspector__objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}


/* harmony default export */ var products_Inspector = (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === undefined ? {} : _ref$styles,
      props = products_Inspector__objectWithoutProperties(_ref, ["styles"]);

  return external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("svg", products_Inspector__extends({ viewBox: "0 0 40.53 40.53" }, props), external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("path", { className: styles["oc-icon-product"] || "oc-icon-product", d: "M37.1 20.36h-3.32a.71.71 0 0 0-.47.12 6.55 6.55 0 0 0-4.26-1.66A6.23 6.23 0 0 0 24.2 21a5.68 5.68 0 0 0-3.79-1.3 5 5 0 0 0-3.66 1.3 6.07 6.07 0 0 0-4.73-2 6.49 6.49 0 0 0-4.38 1.6.71.71 0 0 0-.47-.12H3.86a1.19 1.19 0 0 0-1.18 1.18 1.12 1.12 0 0 0 1.18 1.18h2.36A3 3 0 0 0 6 24c0 2.84 2.72 5.2 5.91 5.2s5.91-2.37 5.91-5.2a2.31 2.31 0 0 0-.12-.95A2.86 2.86 0 0 1 20.3 22a4.14 4.14 0 0 1 2.84.95A3.27 3.27 0 0 0 23 24c0 2.84 2.72 5.2 5.91 5.2s5.91-2.37 5.91-5.2a4.25 4.25 0 0 0-.24-1.3H37a1.19 1.19 0 0 0 1.18-1.18 1.09 1.09 0 0 0-1.08-1.16zM12 26.87c-2 0-3.67-1.3-3.67-2.84S10 21.19 12 21.19s3.67 1.3 3.67 2.84S14 26.87 12 26.87zm17 0c-2 0-3.67-1.3-3.67-2.84s1.66-2.84 3.67-2.84 3.67 1.3 3.67 2.84-1.61 2.84-3.62 2.84z" }));
});
// CONCATENATED MODULE: ./icons/images/invoices/document/generic.svg
var generic__extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function generic__objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}


/* harmony default export */ var generic = (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === undefined ? {} : _ref$styles,
      props = generic__objectWithoutProperties(_ref, ["styles"]);

  return external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("svg", generic__extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 30 30" }, props), external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("g", { fill: "#67707c" }, external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("path", { d: "M16.57 7.39v5.28h4.52l-4.52-5.28z" }), external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("path", { d: "M22 14.67h-7.43V7H8v16h14v-8.33z" })));
});
// CONCATENATED MODULE: ./icons/images/invoices/document/pdf.svg
var pdf__extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function pdf__objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}


/* harmony default export */ var pdf = (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === undefined ? {} : _ref$styles,
      props = pdf__objectWithoutProperties(_ref, ["styles"]);

  return external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("svg", pdf__extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 30 30" }, props), external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("g", { fill: "#67707c" }, external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("path", { d: "M16.57 7.39v5.28h4.52l-4.52-5.28z" }), external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("path", { d: "M22 14.67h-7.43V7H8v16h14" })), external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("text", { transform: "translate(9.01 21.13)", fontSize: "6", fill: "#fff", fontFamily: "Lato" }, "PDF"));
});
// CONCATENATED MODULE: ./icons/images/invoices/document/png.svg
var png__extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function png__objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}


/* harmony default export */ var png = (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === undefined ? {} : _ref$styles,
      props = png__objectWithoutProperties(_ref, ["styles"]);

  return external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("svg", png__extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 30 30" }, props), external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("g", { fill: "#67707c" }, external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("path", { d: "M16.57 7.39v5.28h4.52l-4.52-5.28z" }), external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("path", { d: "M22 14.67h-7.43V7H8v16h14v-8.33z" })), external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("text", { transform: "translate(8.67 21.13)", fontSize: "6", fill: "#fff", fontFamily: "Lato" }, "PNG"));
});
// CONCATENATED MODULE: ./icons/images/invoices/document/ppt.svg
var ppt__extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function ppt__objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}


/* harmony default export */ var ppt = (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === undefined ? {} : _ref$styles,
      props = ppt__objectWithoutProperties(_ref, ["styles"]);

  return external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("svg", ppt__extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 30 30" }, props), external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("path", { fill: "#67707c", d: "M16.57 7.39v5.28h4.52l-4.52-5.28z" }), external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("path", { d: "M22 14.67h-7.43V7H8v16h14v-8.33z", fill: "#67707c" }), external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("text", { transform: "translate(9.36 21.13)", fontSize: "6", fill: "#fff", fontFamily: "Lato" }, "PPT"));
});
// CONCATENATED MODULE: ./icons/images/invoices/document/word.svg
var word__extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function word__objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}


/* harmony default export */ var word = (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === undefined ? {} : _ref$styles,
      props = word__objectWithoutProperties(_ref, ["styles"]);

  return external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("svg", word__extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 30 30" }, props), external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("g", { fill: "#67707c" }, external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("path", { d: "M16.57 7.39v5.28h4.52l-4.52-5.28z" }), external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("path", { d: "M22 14.67h-7.43V7H8v16h14v-8.33z" })), external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("text", { transform: "translate(8.39 21.13)", fontSize: "6", fill: "#fff", fontFamily: "Lato" }, "DOC"));
});
// CONCATENATED MODULE: ./icons/images/invoices/document/xls.svg
var xls__extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function xls__objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}


/* harmony default export */ var xls = (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === undefined ? {} : _ref$styles,
      props = xls__objectWithoutProperties(_ref, ["styles"]);

  return external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("svg", xls__extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 30 30" }, props), external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("g", { fill: "#67707c" }, external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("path", { d: "M16.57 7.39v5.28h4.52l-4.52-5.28z" }), external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("path", { d: "M22 14.67h-7.43V7H8v16h14v-8.33z" })), external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("text", { transform: "translate(9.67 21.13)", fontSize: "6", fill: "#fff", fontFamily: "Lato" }, "XLS"));
});
// CONCATENATED MODULE: ./icons/images/logo/oc-logo.svg
var oc_logo__extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function oc_logo__objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}


/* harmony default export */ var oc_logo = (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === undefined ? {} : _ref$styles,
      props = oc_logo__objectWithoutProperties(_ref, ["styles"]);

  return external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("svg", oc_logo__extends({ viewBox: "0 0 150 30" }, props), external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("path", { className: styles["oc-icon-logo"] || "oc-icon-logo", d: "M75.2 22.5h2c.6 0 1.2-.2 1.8-.3.4-.1.7-.4.7-.8.1-.5.2-1 .3-1.4.1-.3-.1-.4-.3-.4-.4 0-.8.1-1.2.1-1.6.2-3.1.3-4.7 0-1.1-.2-2-.7-2.3-1.8-.1-.4-.2-.8-.2-1.2-.1-1.8.3-3.5.7-5.3.3-1.2.6-2.4 1.3-3.5.6-1 1.5-1.7 2.6-1.9 1.3-.2 2.7-.1 4.1 0 .7 0 1.4.1 2.1.2.3 0 .5-.1.5-.4.1-.5.2-.9.3-1.4.1-.6 0-.8-.6-.9-2.4-.4-4.9-.4-7.3 0-2.7.4-4.7 1.8-5.8 4.3-1.3 3.3-2 6.7-1.9 10.2.1 2.1 1.2 3.5 3.2 4.1 1.5.4 3.1.5 4.7.4zM40.5 8.7c-.5 0-.6.1-.7.6-.4 2.2-.9 4.4-1.3 6.7-.2 1.1-.5 2.3-.5 3.4.1 1 .5 1.8 1.3 2.2.3.2.7.3 1.1.4 2.4.5 4.9.5 7.3-.1 1.6-.4 2.7-1.4 3.2-3l.3-1.2c.6-2.9 1.1-5.7 1.6-8.6.1-.4 0-.5-.4-.5h-2.7c-.4 0-.6.1-.6.5l-1.2 6.6c-.2.9-.4 1.8-.6 2.6-.1.6-.5 1-1.1 1.1-1.1.3-2.3.3-3.5 0-.5-.1-.7-.4-.8-1v-.6c.1-.8.3-1.6.4-2.5.4-2.1.8-4.1 1.2-6.1.1-.5 0-.5-.5-.5-.4.1-2.1 0-2.5 0zM58.3 8.7c-1.7.3-3 1.2-3.4 3-.1.2-.1.5-.2.7-.3 1.5.2 2.4 1.5 3.1.4.2.9.4 1.4.6.8.3 1.6.7 2.4 1 .3.1.6.3.6.7.1.9-.3 1.6-1.2 1.7-.7.1-1.5.2-2.2.2-1.1 0-2.1-.2-3.1-.3-.4 0-.6 0-.7.5-.1.5-.2 1-.3 1.6-.1.3.1.6.4.7.1 0 .2.1.3.1 1.5.3 3.1.3 4.6.2 1.1-.1 2.2-.2 3.3-.7 1.8-.8 3.1-3.1 2.7-5.1-.1-.7-.6-1.3-1.2-1.6-1-.5-2-.9-3.1-1.3-.4-.2-.8-.3-1.2-.5-.5-.3-.6-.6-.5-1.1.2-.6.5-1 1.2-1 1-.1 2-.1 3 0 .6 0 1.2.1 1.8.2.3 0 .6-.1.6-.5.1-.4.2-.8.2-1.2.1-.3-.1-.6-.4-.7-.2-.1-.4-.1-.6-.1-.6-.4-4.8-.4-5.9-.2zM128.2 11.5h1.8c.3 0 .4-.1.5-.4.1-.6.2-1.2.3-1.7.1-.4 0-.5-.4-.5H127c-.5 0-.6-.1-.6-.6 0-.7.1-1.3.1-2 0-.4-.1-.5-.5-.5h-2.2c-.4 0-.5.2-.6.5-.8 4-1.5 8-2.3 12-.1.7-.3 1.4-.1 2.1.2 1 1 1.5 1.9 1.7 1.4.4 2.9.3 4.3.3.4 0 .8-.1 1.2-.2.3-.1.6-.3.6-.5.2-.6.3-1.2.3-1.8 0-.1-.2-.3-.3-.3-.1-.1-.3 0-.4 0-.9 0-1.9.1-2.8 0-.8-.1-1.2-.6-1-1.4.4-2.1.8-4.2 1.2-6.2.1-.4.2-.5.6-.5h1.8zM115.1 22.3h1.3c.5 0 .6-.1.7-.6.3-1.7.6-3.4 1-5.1.5-2.5.9-4.9 1.4-7.4.1-.5 0-.6-.5-.6h-2.6c-.5 0-.6.1-.7.6l-1.5 7.8c-.3 1.6-.6 3.1-.9 4.7-.1.4 0 .6.5.6h1.3zM118.1 6.5h1.4c.3 0 .5-.1.6-.5.1-.7.3-1.5.4-2.2.1-.5 0-.6-.5-.6h-2.5c-.5 0-.6.1-.7.6-.1.7-.3 1.5-.4 2.2-.1.4 0 .5.4.5h1.3zM18.4 3.8c-.4-.2-.9-.3-1.3-.4-1.9-.4-3.8-.3-5.7-.1-2.8.4-4.9 1.8-6 4.5-.6 1.5-1 3.1-1.3 4.7-.4 1.9-.7 3.9-.5 5.8.2 1.8 1 3.1 2.8 3.7 1.3.5 2.7.5 4.4.6.6 0 1.5-.1 2.4-.2 2.7-.4 4.6-1.7 5.8-4.2.6-1.4 1-3 1.3-4.5.4-2 .8-4 .7-6.1-.2-1.7-.9-3.1-2.6-3.8zm-1.8 8.3c-.2 1.6-.6 3.3-1.1 4.8-.1.3-.2.6-.4.8-.6 1.3-1.7 1.9-3.1 2-.9 0-1.9 0-2.8-.1-1.1-.1-1.7-.8-1.8-1.9-.2-1.3.1-2.6.3-3.9.3-1.6.7-3.1 1.1-4.7.1-.5.4-1 .6-1.4.6-1 1.5-1.5 2.6-1.6.5-.1 1-.1 1.5-.1s1 .1 1.4.1c1.3.2 2.1.9 2 2.4 0 1.2-.1 2.4-.3 3.6zM109.2 8.8c2 .4 2.8 1.4 2.8 3.4 0 2.4-.4 4.7-1.6 6.9-1.1 2-2.8 3.1-5.1 3.3-1.4.1-2.8.1-4.2-.3-.4-.1-.5 0-.6.4-.3 1.7-.6 3.7-1 5.4-.1.6-.2 1-.8 1h-2.4c-.5 0-.6-.3-.5-.9.9-4.6 1.7-9.2 2.6-13.8.2-.8.4-1.7.7-2.5.6-1.5 1.9-2.4 3.4-2.7 1.2-.4 5.7-.5 6.7-.2zm-3.5 2.3c-.4 0-.8.1-1.2.1-1 .2-1.7.6-2 1.7-.2.6-.4 1.2-.5 1.9-.2 1.2-.4 2.4-.5 3.6-.1.7.3 1 .9 1.1.5.1 1.1.1 1.6.2 1.6 0 2.5-.5 3-2 .4-1 .6-2.1.8-3.2.1-.6.1-1.2.1-1.9 0-.8-.5-1.3-1.3-1.4-.3 0-.6 0-.9-.1zM30.5 8.5c1.1 0 2.3 0 3.4.3 1.6.5 2.4 1.3 2.5 3 .1 2.6-.4 5.2-1.7 7.5-1.1 1.9-2.8 2.8-4.9 3-1.4.1-2.9.1-4.3-.3-.3-.1-.5 0-.5.4-.3 1.8-.7 3.6-1 5.3-.1.4-.2.5-.6.5h-2.6c-.6 0-.7-.1-.6-.7.4-2.2.8-4.3 1.2-6.5.4-2.4.9-4.7 1.4-7.1.1-.6.3-1.2.5-1.8.6-2 2-3.2 4-3.5 1 0 3.2-.2 3.2-.1zm-2.3 11.2c1.3 0 2.4-.3 3-1.6.8-1.6 1.1-3.4 1.1-5.2 0-1.1-.5-1.6-1.5-1.7-.7-.1-1.5 0-2.2.1-1 .1-1.6.7-1.8 1.7-.2.6-.4 1.3-.5 1.9-.2 1.1-.4 2.2-.5 3.3-.1.8.2 1.1 1 1.3.5.2 1 .2 1.4.2zM138.4 13.7h2.2c.3 0 .5-.1.5-.4 0-.4.1-.7 0-1.1-.1-.6-.6-1-1.3-1.1-1.4-.2-2.8-.1-4.2.1-.6.1-1.1.2-1.7.3-.4 0-.5 0-.4-.5.1-.4.1-.9.2-1.3s.4-.6.7-.7c.7-.2 1.4-.4 2.2-.4 1.2-.1 2.4-.1 3.6-.1.9.1 1.9.2 2.7.5 1.3.4 2 1.4 2 2.8 0 1.2-.2 2.5-.5 3.7l-1.2 6.3c-.1.4-.2.5-.6.5h-.8c-.5.1-.9-.2-1.1-.6-.1-.2-.3-.6-.5-.6-.1-.1-.4.3-.6.4-.9.6-1.9.9-2.9 1-1.1 0-2.2 0-3.3-.1-1.7-.3-2.4-1.2-2.3-3 .1-.9.3-1.7.5-2.5.5-1.7 1.8-2.5 3.5-2.7 1.1-.4 3.2-.5 3.3-.5zm-2 6.3c.4 0 .7-.1 1.1-.1 1.3-.3 2.4-.9 2.7-2.3l.3-1.2c0-.2 0-.4-.3-.4-1.2 0-2.4 0-3.6.1-.6 0-1 .3-1.3.9-.3.7-.4 1.4-.4 2.1 0 .4.3.7.7.8.3.1.6.1.8.1zM91.1 20.9c-.1 0-.1.1-.2.1-1 .9-2.3 1.3-3.7 1.4-1.2.1-2.3.1-3.5-.3-1.3-.4-1.8-1.1-1.9-2.4 0-1.2.2-2.4.7-3.5.6-1.3 1.7-2 3-2.2 1-.2 2-.2 3-.2h2.4c.6 0 .7-.1.8-.7 0-.2.1-.4.1-.5 0-.7-.3-1.3-1-1.4-.8-.1-1.7-.2-2.6-.2-1.1.1-2.2.3-3.3.4h-.4c-.2 0-.3-.1-.3-.3.1-.5.1-1.1.3-1.5.1-.3.5-.5.8-.6.7-.2 1.5-.4 2.3-.4 1.3-.1 2.7-.1 4 0 .8.1 1.6.3 2.4.5 1.2.4 1.7 1.5 1.7 2.7 0 1.2-.2 2.4-.4 3.6l-1.2 6.3c-.1.3-.3.5-.6.5h-.1c-1.6 0-1.4.1-2.1-1.1-.1-.1-.2-.1-.2-.2zm-3.9-.8c.4 0 .8-.1 1.2-.1 1.2-.2 2.1-.8 2.6-2.1.2-.5.2-1 .3-1.5.1-.3-.1-.4-.3-.4h-3.2c-.8 0-1.5.2-1.8 1.1-.2.6-.3 1.1-.3 1.7-.1.7.3 1.1.8 1.2.2 0 .4 0 .7.1z" }), external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("path", { className: styles["oc-icon-logo"] || "oc-icon-logo", d: "M64.5 8.6c.2 0 .4.1.6.1.3.1.4.4.4.7-.1.4-.2.8-.2 1.2-.1.4-.3.5-.6.5-.6 0-1.2-.1-1.8-.2h-3c-.7 0-1.1.4-1.2 1-.1.5 0 .9.5 1.1.4.2.8.4 1.2.5 1 .4 2.1.9 3.1 1.3.7.3 1.1.8 1.2 1.6.3 2-.9 4.3-2.7 5.1-1 .5-2.2.6-3.3.7-1.5.1-3.1.1-4.6-.2-.1 0-.2-.1-.3-.1-.3-.1-.5-.3-.4-.7.1-.5.2-1 .3-1.6.1-.4.2-.5.7-.5 1 .1 2.1.2 3.1.3.7 0 1.5 0 2.2-.2.8-.2 1.3-.9 1.2-1.7-.1-.4-.3-.6-.6-.7-.8-.3-1.6-.7-2.4-1-.5-.2-.9-.4-1.4-.6-1.3-.7-1.8-1.6-1.5-3.1 0-.2.1-.5.2-.7.4-1.8 1.7-2.7 3.4-3 .8.1 5 .1 5.9.2z" }));
});
// CONCATENATED MODULE: ./icons/images/logo/oc-logo-short.svg
var oc_logo_short__extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function oc_logo_short__objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}


/* harmony default export */ var oc_logo_short = (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === undefined ? {} : _ref$styles,
      props = oc_logo_short__objectWithoutProperties(_ref, ["styles"]);

  return external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("svg", oc_logo_short__extends({ viewBox: "0 0 50 30" }, props), external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement("path", { className: styles["oc-icon-logo"] || "oc-icon-logo", d: "M35.5 24.7h2.1c.6 0 1.3-.2 1.9-.3.4-.1.7-.4.8-.8l.3-1.5c.1-.3-.1-.4-.3-.4-.4 0-.8.1-1.3.1-1.7.2-3.3.3-5 0-1.2-.2-2.1-.7-2.5-2-.1-.4-.2-.8-.2-1.2-.1-1.9.3-3.7.7-5.6.3-1.3.7-2.5 1.3-3.7.6-1.1 1.6-1.8 2.8-2 1.5-.3 2.9-.3 4.4-.2.8 0 1.5.1 2.3.2.3 0 .5-.1.6-.4l.3-1.5c.1-.7 0-.8-.7-.9-2.6-.4-5.2-.4-7.8 0-2.8.4-5 1.9-6.1 4.6-1.4 3.5-2.1 7.1-2 10.8.1 2.2 1.3 3.7 3.4 4.3 1.7.5 3.4.5 5 .5zM22 4.8c-.4-.2-.9-.3-1.4-.4-2-.4-4-.3-6.1-.1-3 .4-5.2 1.9-6.4 4.7-.7 1.6-1.1 3.3-1.4 5-.4 2-.8 4.1-.6 6.2.2 1.9 1.1 3.2 2.9 3.9 1.4.5 2.9.5 4.7.6.6-.1 1.6-.1 2.5-.2 2.8-.4 4.9-1.8 6.1-4.4.7-1.5 1.1-3.1 1.4-4.8.4-2.1.8-4.3.7-6.5.2-1.8-.6-3.2-2.4-4zm-1.9 8.8c-.3 1.7-.6 3.4-1.2 5.1-.1.3-.2.6-.4.9-.7 1.4-1.8 2.1-3.3 2.1-1 0-2 0-3-.1-1.2-.1-1.8-.9-1.9-2-.2-1.4.1-2.8.3-4.2.3-1.7.7-3.3 1.1-5 .1-.5.4-1 .7-1.5.6-1.1 1.5-1.6 2.7-1.7.5-.1 1-.1 1.6-.1.5 0 1 .1 1.5.1 1.4.2 2.2 1 2.1 2.5.1 1.3 0 2.6-.2 3.9z" }));
});
// CONCATENATED MODULE: ./icons/icon.component.jsx
var icon_component__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function icon_component__objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable import/no-duplicates */


















































































































var components = {
  indicator: {
    alert: external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createFactory(Alert),
    arrowLeft: external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createFactory(ArrowLeft),
    attachment: external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createFactory(Attachment),

    burger: external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createFactory(Burger),
    burgerClose: external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createFactory(Burger_close),

    calendar: external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createFactory(Calendar),
    CaretRight: external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createFactory(CaretRight),
    CaretLeft: external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createFactory(CaretLeft),
    CaretDoubleRight: external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createFactory(CaretDoubleRight),
    CaretDoubleLeft: external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createFactory(CaretDoubleLeft),
    clock: external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createFactory(Clock),
    close: external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createFactory(Close),
    comment: external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createFactory(Comment),
    commented: external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createFactory(Commented),
    critical: external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createFactory(Critical),

    delete: external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createFactory(Delete),
    deleted: external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createFactory(Deleted),
    draggingArrows: external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createFactory(DraggingArrows),

    edit: external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createFactory(Edit),
    email: external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createFactory(Email),
    error: external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createFactory(Error),
    exclamation: external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createFactory(Exclamation),
    export: external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createFactory(Export),

    filtering: external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createFactory(Filtering),
    flagged: external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createFactory(Flagged),
    folder: external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createFactory(Folder),

    help: external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createFactory(Help),

    info: external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createFactory(Info),

    inspected: external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createFactory(Inspected),
    inspectedAndApproved: external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createFactory(InspectedAndApproved),
    inspector: external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createFactory(Inspector),

    logout: external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createFactory(Logout),

    matched: external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createFactory(Matched),
    minus: external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createFactory(Minus),
    more: external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createFactory(More),

    ok: external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createFactory(Ok),

    pinned: external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createFactory(Pinned),
    plus: external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createFactory(Plus),
    presentation: external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createFactory(Presentation),
    print: external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createFactory(Print),

    rejected: external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createFactory(Rejected),
    remove: external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createFactory(Remove),
    removeFilter: external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createFactory(RemoveFilter),

    save: external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createFactory(Save),
    search: external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createFactory(Search),
    searchWithCircle: external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createFactory(SearchWithCircle),
    settings: external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createFactory(Settings),
    sortAsc: external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createFactory(SortAsc),
    sortDesc: external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createFactory(SortDesc),
    inClarification: external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createFactory(StatusInclarification),
    locked: external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createFactory(StatusLocked),

    unmatched: external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createFactory(Unmatched),
    user: external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createFactory(StatusUser),

    warning: external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createFactory(Warning),

    exceedsLimit: external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createFactory(ExceedsLimit),

    confirmedSub: external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createFactory(ConfirmedSub),
    partiallySub: external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createFactory(PartiallySub),
    errorSub: external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createFactory(ErrorSub),

    confirmed: external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createFactory(Confirmed),
    errorSmall: external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createFactory(ErrorSmall),
    notStarted: external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createFactory(NotStarted),
    partially: external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createFactory(Partially),

    average: external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createFactory(Average),
    last: external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createFactory(Last),
    max: external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createFactory(Max),
    min: external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createFactory(Min)
  },
  product: {
    Invoices: external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createFactory(Invoices),
    user: external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createFactory(User),
    Accounts: external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createFactory(Accounts),
    Archive: external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createFactory(Archive),
    Dashboard: external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createFactory(Dashboard),
    Info: external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createFactory(products_Info),
    Liquidity: external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createFactory(Liquidity),
    Netting: external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createFactory(Netting),
    Payments: external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createFactory(Payments),
    Settings: external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createFactory(products_Settings),
    Tools: external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createFactory(Tools),
    Users: external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createFactory(Users),
    Examples: external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createFactory(products_Info),
    Matching: external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createFactory(Matching),
    Inspector: external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createFactory(products_Inspector)
  },
  invoices: {
    generic: external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createFactory(generic),
    pdf: external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createFactory(pdf),
    png: external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createFactory(png),
    ppt: external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createFactory(ppt),
    word: external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createFactory(word),
    xls: external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createFactory(xls)
  },
  logo: {
    OCShort: external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createFactory(oc_logo_short),
    OCLong: external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createFactory(oc_logo)
  }
};

var icon_component_Icon = function (_React$Component) {
  _inherits(Icon, _React$Component);

  function Icon(props) {
    _classCallCheck(this, Icon);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    switch (props.type) {
      case 'product':
        {
          _this.defaultWidth = 40;
          _this.defaultHeight = 40;
          break;
        }
      case 'indicator':
        {
          _this.defaultWidth = 25;
          _this.defaultHeight = 25;
          break;
        }
      case 'logo':
        {
          if (props.name === 'OCLong') {
            _this.defaultWidth = 150;
            _this.defaultHeight = 30;
          } else {
            _this.defaultWidth = 50;
            _this.defaultHeight = 30;
          }
          break;
        }
      default:
        _this.defaultWidth = 40;
        _this.defaultHeight = 40;
    }
    return _this;
  }

  Icon.prototype.render = function render() {
    var _props = this.props,
        type = _props.type,
        name = _props.name,
        width = _props.width,
        height = _props.height,
        otherProps = icon_component__objectWithoutProperties(_props, ['type', 'name', 'width', 'height']);

    var component = components[type] && components[type][name];
    var properties = icon_component__extends({
      width: width || this.defaultWidth,
      height: height || this.defaultHeight,
      focusable: 'false'
    }, otherProps);
    if (typeof Logout === 'function') {
      return component(properties);
    }
    return external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.createElement('span', icon_component__extends({ className: 'icon' }, this.props));
  };

  return Icon;
}(external___root___React___commonjs2___react___commonjs___react___amd___react___umd___react___default.a.Component);




icon_component_Icon.defaultProps = {
  width: null,
  height: null
};
// CONCATENATED MODULE: ./icons/index.js


// CONCATENATED MODULE: ./index.js
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Icon", function() { return icon_component_Icon; });


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(4)();
}


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(5);

function emptyFunction() {}

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// react-icons.min.js